export const legacyPools = [
  {
    cmsDetails: {
      id: 14,
      createToken: [
        {
          __component: 'create-token.create-token',
          id: 158,
          createTokenFromSol: {
            id: 193,
            name: 'LithiumTEMP.sol',
            alternativeText: '',
            caption: '',
            width: null,
            height: null,
            formats: null,
            hash: 'Lithium_TEMP_5308fd5262',
            ext: '.sol',
            mime: 'application/octet-stream',
            size: 0.32,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/Lithium_TEMP_5308fd5262.sol',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-03-01T09:30:43.704Z',
            updated_at: '2022-03-01T09:30:43.723Z',
          },
        },
      ],
      name: 'LUNAFI',
      initialAddress: null,
      poolAddress: '0x03c3015a57e391d3a8c4d69520097cf031df28f7',
      ticker: 'LFI',
      totalSupply: null,
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '200',
      token: 'dummytoken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      published_at: '2022-03-17T12:00:05.043Z',
      created_at: '2021-11-17T11:04:53.983Z',
      updated_at: '2022-05-23T09:57:48.399Z',
      thresholdPublicAmount: '99',
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: false,
      mainNet: null,
      totalSaleSupply: '1666667',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '50000',
      chainID: '56',
      displayPoolDetail: true,
      lockedToken: '0',
      lockedValue: '1',
      allowClaim: true,
      isDeployed: true,
      initialTokenAddress: null,
      launchpadFee: '0',
      polygonTokensales: false,
      tokenAddressInPolygon: null,
      createDistributorOnPolygon: false,
      polygoneAddressDistributor: null,
      listingType: 'Public',
      isFeaturedProject: true,
      claimLocation: null,
      crossChainLink: 'Matic',
      athSinceIDO: null,
      escrowBlock: {
        id: 12,
        escrowBlock: null,
        escrowPercentage: '0',
        escrowMilestones: [
          {
            id: 122,
            milestone: 1,
            escrowReturn: 0,
          },
        ],
      },
      blacklist: [],
      about: {
        id: 14,
        description: null,
        webinar: null,
        highlightsText:
          'LunaFi is the world’s first decentralised, peerless sportsbook. It aims to make community members ‘the house’ and offers customers the chance to bet in a completely transparent and immutable way, via the blockchain. You can choose to earn a passive income by staking your liquidity in the house pool, by taking your chances with a bet, or both! The $LFI token underpins the entire ecosystem, giving holders governance rights, ownership, revenue share, and other rewards.',
        productText:
          "One of the reasons we are so excited about LunaFi is the vision of the product they are offering. They are seeking to add value at every stage of the customer journey, creating a platform that is an absolute joy to use. LunaFi's initial product will be split out into a few key elements:\n- Liquidity Pools — Investors can stake USDC/WETH/WBTC and earn profits in the respective token + $LFI rewards for participating in the pool. This pool is the counterparty to bets struck on the protocol.\n- Sportsbook — Blockchain-based sportsbook secured by a global decentralized network. Bet anywhere without depositing knowing your funds are secure in the house pool.\n- Casino — With the best slots and card games available, you can play on Lunabets safe in the knowledge the platform will always meet payouts.\n- ETH & BTC price prediction — User friendly design, focused on a simple interface that allows betting on hourly, daily & weekly ETH & BTC closing prices.",
        problemText: null,
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility:
          'At ZAP, we will never back a project whose token doesn’t offer real utility. LunaFi certainly fits the bill, the $LFI token has more utility than you can shake a stick at!\n\nFirst and foremost, the $LFI token can also be used to place bets on any of the games, and enter tournaments offered on the LunaFi platform. But the utility doesn’t end here, holders can also stake tokens to access a share of the profits from the platform and also participate in governance.',
        solutionText: null,
        shortBio: null,
        links: [],
        logo: {
          id: 208,
          name: 'LunaFi Token.png',
          alternativeText: '',
          caption: '',
          width: 367,
          height: 367,
          formats: {
            thumbnail: {
              ext: '.png',
              url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_Luna_Fi_Token_1d98c6b16c.png',
              hash: 'thumbnail_Luna_Fi_Token_1d98c6b16c',
              mime: 'image/png',
              name: 'thumbnail_LunaFi Token.png',
              path: null,
              size: 6.15,
              width: 156,
              height: 156,
            },
          },
          hash: 'Luna_Fi_Token_1d98c6b16c',
          ext: '.png',
          mime: 'image/png',
          size: 7.6,
          url: 'https://lithium-production.s3.us-west-1.amazonaws.com/Luna_Fi_Token_1d98c6b16c.png',
          previewUrl: null,
          provider: 'aws-s3',
          provider_metadata: null,
          created_at: '2022-03-17T11:49:40.539Z',
          updated_at: '2022-05-12T11:48:13.657Z',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      team: [
        {
          id: 90,
          name: 'George Porchester',
          position: 'CEO, Founder ',
          links: [
            {
              id: 229,
              title: 'LinkedIn',
              link: 'https://www.linkedin.com/in/george-porchester-5b3b188b/',
            },
          ],
          avatar: {
            id: 209,
            name: '1579615306406.jpeg',
            alternativeText: '',
            caption: '',
            width: 400,
            height: 400,
            formats: {
              thumbnail: {
                ext: '.jpeg',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_1579615306406_c8299e3089.jpeg',
                hash: 'thumbnail_1579615306406_c8299e3089',
                mime: 'image/jpeg',
                name: 'thumbnail_1579615306406.jpeg',
                path: null,
                size: 4.79,
                width: 156,
                height: 156,
              },
            },
            hash: '1579615306406_c8299e3089',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 29.26,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/1579615306406_c8299e3089.jpeg',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-03-17T12:06:13.057Z',
            updated_at: '2022-03-17T12:06:13.073Z',
          },
        },
        {
          id: 91,
          name: 'James Hume',
          position: 'CFO',
          links: [
            {
              id: 230,
              title: 'LinkedIn',
              link: 'https://www.linkedin.com/in/james-hume-ma-att-cta-777112/',
            },
          ],
          avatar: {
            id: 210,
            name: '1516190232857.jpeg',
            alternativeText: '',
            caption: '',
            width: 161,
            height: 161,
            formats: {
              thumbnail: {
                ext: '.jpeg',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_1516190232857_ac2a455da5.jpeg',
                hash: 'thumbnail_1516190232857_ac2a455da5',
                mime: 'image/jpeg',
                name: 'thumbnail_1516190232857.jpeg',
                path: null,
                size: 6.47,
                width: 156,
                height: 156,
              },
            },
            hash: '1516190232857_ac2a455da5',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 6.74,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/1516190232857_ac2a455da5.jpeg',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-03-17T12:07:00.476Z',
            updated_at: '2022-03-17T12:07:00.488Z',
          },
        },
        {
          id: 92,
          name: 'Garrett Parris',
          position: 'Full Stack Developer',
          links: [
            {
              id: 231,
              title: 'LinkedIn',
              link: 'https://www.linkedin.com/in/garrettparris/',
            },
          ],
          avatar: {
            id: 211,
            name: '1562872358676.jpeg',
            alternativeText: '',
            caption: '',
            width: 400,
            height: 400,
            formats: {
              thumbnail: {
                ext: '.jpeg',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_1562872358676_3dadec36de.jpeg',
                hash: 'thumbnail_1562872358676_3dadec36de',
                mime: 'image/jpeg',
                name: 'thumbnail_1562872358676.jpeg',
                path: null,
                size: 6.81,
                width: 156,
                height: 156,
              },
            },
            hash: '1562872358676_3dadec36de',
            ext: '.jpeg',
            mime: 'image/jpeg',
            size: 30.78,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/1562872358676_3dadec36de.jpeg',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-03-17T12:07:56.026Z',
            updated_at: '2022-03-17T12:07:56.039Z',
          },
        },
      ],
      publicSale: {
        id: 13,
        start: '2022-05-18T17:01:00.000Z',
        end: '2022-05-18T17:02:00.000Z',
        price: '0.03',
      },
      privateSale: {
        id: 14,
        start: '2022-06-01T17:00:00.000Z',
        end: '2022-06-02T17:00:00.000Z',
        price: '0.03',
      },
      vestingPoints: [
        {
          id: 170,
          timePoint: '2022-12-01T12:00:00.000Z',
          percent: 100,
        },
      ],
      poolContract: [],
      media: {
        id: 1,
        topBanner: {
          id: 220,
          name: 'luna-dark.jpg',
          alternativeText: '',
          caption: '',
          width: 2940,
          height: 1200,
          formats: {
            large: {
              ext: '.jpg',
              url: 'https://lithium-production.s3.us-west-1.amazonaws.com/large_luna_dark_6b92f44dff.jpg',
              hash: 'large_luna_dark_6b92f44dff',
              mime: 'image/jpeg',
              name: 'large_luna-dark.jpg',
              path: null,
              size: 34.44,
              width: 1000,
              height: 408,
            },
            small: {
              ext: '.jpg',
              url: 'https://lithium-production.s3.us-west-1.amazonaws.com/small_luna_dark_6b92f44dff.jpg',
              hash: 'small_luna_dark_6b92f44dff',
              mime: 'image/jpeg',
              name: 'small_luna-dark.jpg',
              path: null,
              size: 11.96,
              width: 500,
              height: 204,
            },
            medium: {
              ext: '.jpg',
              url: 'https://lithium-production.s3.us-west-1.amazonaws.com/medium_luna_dark_6b92f44dff.jpg',
              hash: 'medium_luna_dark_6b92f44dff',
              mime: 'image/jpeg',
              name: 'medium_luna-dark.jpg',
              path: null,
              size: 22.69,
              width: 750,
              height: 306,
            },
            thumbnail: {
              ext: '.jpg',
              url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_luna_dark_6b92f44dff.jpg',
              hash: 'thumbnail_luna_dark_6b92f44dff',
              mime: 'image/jpeg',
              name: 'thumbnail_luna-dark.jpg',
              path: null,
              size: 4.19,
              width: 245,
              height: 100,
            },
          },
          hash: 'luna_dark_6b92f44dff',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 154.32,
          url: 'https://lithium-production.s3.us-west-1.amazonaws.com/luna_dark_6b92f44dff.jpg',
          previewUrl: null,
          provider: 'aws-s3',
          provider_metadata: null,
          created_at: '2022-04-15T09:34:00.630Z',
          updated_at: '2022-04-15T09:34:00.642Z',
        },
        projectThumbnail: {
          id: 216,
          name: '290x180 (1).png',
          alternativeText: '',
          caption: '',
          width: 290,
          height: 180,
          formats: {
            thumbnail: {
              ext: '.png',
              url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_290x180_1_18603f39a1.png',
              hash: 'thumbnail_290x180_1_18603f39a1',
              mime: 'image/png',
              name: 'thumbnail_290x180 (1).png',
              path: null,
              size: 83.89,
              width: 245,
              height: 152,
            },
          },
          hash: '290x180_1_18603f39a1',
          ext: '.png',
          mime: 'image/png',
          size: 94.84,
          url: 'https://lithium-production.s3.us-west-1.amazonaws.com/290x180_1_18603f39a1.png',
          previewUrl: null,
          provider: 'aws-s3',
          provider_metadata: null,
          created_at: '2022-04-15T08:02:38.551Z',
          updated_at: '2022-04-15T08:02:38.565Z',
        },
        featuredProjectImage: [
          {
            id: 263,
            name: 'luna-fw.png',
            alternativeText: '',
            caption: '',
            width: 510,
            height: 510,
            formats: {
              small: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/small_luna_fw_b002e9db5b.png',
                hash: 'small_luna_fw_b002e9db5b',
                mime: 'image/png',
                name: 'small_luna-fw.png',
                path: null,
                size: 397.45,
                width: 500,
                height: 500,
              },
              thumbnail: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_luna_fw_b002e9db5b.png',
                hash: 'thumbnail_luna_fw_b002e9db5b',
                mime: 'image/png',
                name: 'thumbnail_luna-fw.png',
                path: null,
                size: 41.7,
                width: 156,
                height: 156,
              },
            },
            hash: 'luna_fw_b002e9db5b',
            ext: '.png',
            mime: 'image/png',
            size: 282.08,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/luna_fw_b002e9db5b.png',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-05-05T14:43:19.476Z',
            updated_at: '2022-05-05T14:43:19.497Z',
          },
        ],
        highlightsVideo: {
          id: 283,
          name: 'LunaFi.mp4',
          alternativeText: '',
          caption: '',
          width: null,
          height: null,
          formats: null,
          hash: 'Luna_Fi_98cdd255af',
          ext: '.mp4',
          mime: 'video/mp4',
          size: 130169.09,
          url: 'https://lithium-production.s3.us-west-1.amazonaws.com/Luna_Fi_98cdd255af.mp4',
          previewUrl: null,
          provider: 'aws-s3',
          provider_metadata: null,
          created_at: '2022-05-17T10:40:57.609Z',
          updated_at: '2022-05-17T10:40:57.627Z',
        },
      },
      topLinks: {
        id: 1,
        website: 'https://www.lunafi.io/',
        whitepaper: 'https://docs.lunafi.io/lunafi/',
        twitter: 'https://twitter.com/LunaFi_Project',
        telegram: 'https://t.me/LunaFi_Official',
        discord: 'https://discord.com/invite/j2wDzZCshq',
        medium: null,
      },
      vestingTableRow: [
        {
          id: 1,
          percent: 100,
          label: 'TGE',
        },
      ],
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 211,
    },
    isBusd: true,
    privateEnd: 1646499600,
    privateStart: 1646413200,
    privateTokenPrice: '30000000000000000',
    tokenName: 'LunaFi',
    tokenSymbol: 'LFI',
    totalSaleSupply: '2.22223e+23',
  },
  {
    cmsDetails: {
      id: 186,
      createToken: [
        {
          __component: 'create-token.create-token',
          id: 163,
          createTokenFromSol: {
            id: 214,
            name: 'LithiumTEMP.sol',
            alternativeText: '',
            caption: '',
            width: null,
            height: null,
            formats: null,
            hash: 'Lithium_TEMP_b119cfe408',
            ext: '.sol',
            mime: 'application/octet-stream',
            size: 0.32,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/Lithium_TEMP_b119cfe408.sol',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-03-18T11:11:33.046Z',
            updated_at: '2022-03-18T11:11:33.068Z',
          },
        },
      ],
      name: 'Tangible',
      initialAddress: null,
      poolAddress: '0xdc45b116a871e1086c488b2e86b3b546daebde94',
      ticker: 'TNGBL',
      totalSupply: null,
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '1',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      published_at: '2022-04-29T14:15:51.573Z',
      created_at: '2022-04-29T14:15:48.985Z',
      updated_at: '2022-04-29T14:17:14.759Z',
      thresholdPublicAmount: '100',
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '25000',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '50000',
      chainID: '56',
      displayPoolDetail: true,
      lockedToken: '1',
      lockedValue: null,
      allowClaim: true,
      isDeployed: true,
      initialTokenAddress: null,
      launchpadFee: '0',
      polygonTokensales: false,
      tokenAddressInPolygon: null,
      createDistributorOnPolygon: false,
      polygoneAddressDistributor: null,
      listingType: 'Seed',
      isFeaturedProject: true,
      claimLocation: null,
      crossChainLink: 'Matic',
      athSinceIDO: null,
      escrowBlock: {
        id: 165,
        escrowBlock: null,
        escrowPercentage: '0',
        escrowMilestones: [],
      },
      blacklist: [],
      about: {
        id: 158,
        description: null,
        webinar: null,
        highlightsText:
          'Diversification against Bear market cycles. Earn passive income through holding $TNGBL. Seed Price / fairer launch model. Tradable NFTs to reduce Vesting Cycle. ',
        productText:
          'Tangible is a marketplace that allows its users to purchase physical collectible goods from leading global suppliers through NFTs. Upon purchase, a Tangible NFT represents an underlying physical collector item, ranging from rare vintage wines, collector watches, gold, rare sneakers, or even (pieces of) real estate. These TNFTs can then be held, fractionalised, and traded. The owner of a TNFTs can also redeem the underlying physical item at any point.',
        problemText:
          "On one hand, the market for most alternative asset classes is incredibly illiquid; trading wholes or shares of wine, real estate, luxury goods, etc. is traditionally difficult or impossible. In order to facilitate transactions of rare collector goods or real estate, often multiple parties (sometimes across the world) need to be involved, storage and transport ensured, or long distances travelled. On the other hand, investors in the crypto ecosystem experience extreme volatility by holding cryptocurrencies, project tokens, or hyped NFTs. Besides stablecoins, not many low-volatility assets exist in the space. Then again, stablecoins aren't investments that generate returns.",
        businessModalText: null,
        marketText: null,
        investorsText:
          'Tangible has also already received solid backing from the likes of Sky Vision Capital, Master Ventures, Nxgen, and many more.',
        tokenUtility:
          'All tokens purchased in the seed round will be automatically locked up in an NFT and transferred to the investor. This NFT will then earn passive income at the highest possible multiplier (25x). Passive income is generated from transactions on the Tangible marketplace—66% of all marketplace revenue is distributed among token holders and 33% of all marketplace revenue is used to buyback and burn tokens, creating a deflationary token. ',
        solutionText:
          'Alternative assets such as collector goods are an often overlooked and incredibly efficient store of value, especially during times of high inflation and few feasible low-volatility alternatives. Transferring product information and value onto the blockchain allows owning and trading these physical goods without actually holding them (physically). This use of NFTs facilitates trade and creates a liquid market for traditionally illiquid collector goods and real estate. All goods traded on the Tangible marketplace are provided by partners and stored in highly secure physical vaults. Ultimately, Tangible gives its users access to and provides liquid markets for collector goods that are typically cumbersome to trade. In addition, Tangible provides the crypto native community with low volatility assets and significant long-term value.',
        shortBio: null,
        links: [],
        logo: {
          id: 242,
          name: 'https://res.cloudinary.com/lithium/image/upload/v1650974186/v2/TNGBL-token_y8rrx4.png',
          alternativeText: '',
          caption: '',
          width: 2000,
          height: 2000,
          formats: {
            large: {
              ext: '.png',
              url: 'https://lithium-production.s3.us-west-1.amazonaws.com/large_TNGBL_token_y8rrx4_b327fafde6.png',
              hash: 'large_TNGBL_token_y8rrx4_b327fafde6',
              mime: 'image/png',
              name: 'large_https://res.cloudinary.com/lithium/image/upload/v1650974186/v2/TNGBL-token_y8rrx4.png',
              path: null,
              size: 107.62,
              width: 1000,
              height: 1000,
            },
            small: {
              ext: '.png',
              url: 'https://lithium-production.s3.us-west-1.amazonaws.com/small_TNGBL_token_y8rrx4_b327fafde6.png',
              hash: 'small_TNGBL_token_y8rrx4_b327fafde6',
              mime: 'image/png',
              name: 'small_https://res.cloudinary.com/lithium/image/upload/v1650974186/v2/TNGBL-token_y8rrx4.png',
              path: null,
              size: 45.48,
              width: 500,
              height: 500,
            },
            medium: {
              ext: '.png',
              url: 'https://lithium-production.s3.us-west-1.amazonaws.com/medium_TNGBL_token_y8rrx4_b327fafde6.png',
              hash: 'medium_TNGBL_token_y8rrx4_b327fafde6',
              mime: 'image/png',
              name: 'medium_https://res.cloudinary.com/lithium/image/upload/v1650974186/v2/TNGBL-token_y8rrx4.png',
              path: null,
              size: 75.23,
              width: 750,
              height: 750,
            },
            thumbnail: {
              ext: '.png',
              url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_TNGBL_token_y8rrx4_b327fafde6.png',
              hash: 'thumbnail_TNGBL_token_y8rrx4_b327fafde6',
              mime: 'image/png',
              name: 'thumbnail_https://res.cloudinary.com/lithium/image/upload/v1650974186/v2/TNGBL-token_y8rrx4.png',
              path: null,
              size: 11.18,
              width: 156,
              height: 156,
            },
          },
          hash: 'TNGBL_token_y8rrx4_b327fafde6',
          ext: '.png',
          mime: 'image/png',
          size: 80.42,
          url: 'https://lithium-production.s3.us-west-1.amazonaws.com/TNGBL_token_y8rrx4_b327fafde6.png',
          previewUrl: null,
          provider: 'aws-s3',
          provider_metadata: null,
          created_at: '2022-04-26T21:45:28.561Z',
          updated_at: '2022-04-26T21:45:28.577Z',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      team: [
        {
          id: 113,
          name: 'Jag Singh',
          position: 'CEO',
          links: [
            {
              id: 253,
              title: null,
              link: 'https://www.linkedin.com/in/jag-singh-b5a272130/',
            },
          ],
          avatar: {
            id: 257,
            name: '1630348662245.jpg',
            alternativeText: '',
            caption: '',
            width: 400,
            height: 400,
            formats: {
              thumbnail: {
                ext: '.jpg',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_1630348662245_5023416ff4.jpg',
                hash: 'thumbnail_1630348662245_5023416ff4',
                mime: 'image/jpeg',
                name: 'thumbnail_1630348662245.jpg',
                path: null,
                size: 7.24,
                width: 156,
                height: 156,
              },
            },
            hash: '1630348662245_5023416ff4',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 45.52,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/1630348662245_5023416ff4.jpg',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-04-28T12:44:52.302Z',
            updated_at: '2022-04-28T12:44:52.321Z',
          },
        },
        {
          id: 114,
          name: 'Andy Deemer',
          position: 'Product',
          links: [
            {
              id: 254,
              title: null,
              link: 'https://www.linkedin.com/in/andydeemer/',
            },
          ],
          avatar: {
            id: 256,
            name: '1630350847414.jpg',
            alternativeText: '',
            caption: '',
            width: 400,
            height: 400,
            formats: {
              thumbnail: {
                ext: '.jpg',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_1630350847414_ef1f61011f.jpg',
                hash: 'thumbnail_1630350847414_ef1f61011f',
                mime: 'image/jpeg',
                name: 'thumbnail_1630350847414.jpg',
                path: null,
                size: 4.32,
                width: 156,
                height: 156,
              },
            },
            hash: '1630350847414_ef1f61011f',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 18.79,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/1630350847414_ef1f61011f.jpg',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-04-28T12:44:33.979Z',
            updated_at: '2022-04-28T12:44:33.993Z',
          },
        },
        {
          id: 115,
          name: 'Michael Slatkin',
          position: 'Marketing',
          links: [
            {
              id: 255,
              title: null,
              link: 'https://www.linkedin.com/in/michael-slatkin/',
            },
          ],
          avatar: {
            id: 255,
            name: '1627330686872.jpg',
            alternativeText: '',
            caption: '',
            width: 400,
            height: 400,
            formats: {
              thumbnail: {
                ext: '.jpg',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_1627330686872_7928f51401.jpg',
                hash: 'thumbnail_1627330686872_7928f51401',
                mime: 'image/jpeg',
                name: 'thumbnail_1627330686872.jpg',
                path: null,
                size: 4.59,
                width: 156,
                height: 156,
              },
            },
            hash: '1627330686872_7928f51401',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 20.7,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/1627330686872_7928f51401.jpg',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-04-28T12:44:27.838Z',
            updated_at: '2022-04-28T12:44:27.849Z',
          },
        },
        {
          id: 116,
          name: 'Daniel Kuppitz',
          position: 'Blockchain Architect',
          links: [
            {
              id: 256,
              title: null,
              link: 'https://www.linkedin.com/in/daniel-kuppitz-5a60b119a/',
            },
          ],
          avatar: {
            id: 254,
            name: '1576219887592.jpg',
            alternativeText: '',
            caption: '',
            width: 399,
            height: 400,
            formats: {
              thumbnail: {
                ext: '.jpg',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_1576219887592_35eb24bcee.jpg',
                hash: 'thumbnail_1576219887592_35eb24bcee',
                mime: 'image/jpeg',
                name: 'thumbnail_1576219887592.jpg',
                path: null,
                size: 6,
                width: 156,
                height: 156,
              },
            },
            hash: '1576219887592_35eb24bcee',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 27.86,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/1576219887592_35eb24bcee.jpg',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-04-28T12:44:01.895Z',
            updated_at: '2022-04-28T12:44:01.907Z',
          },
        },
        {
          id: 117,
          name: 'Pavlo Radchuk',
          position: 'Blockchain Accounter',
          links: [
            {
              id: 257,
              title: null,
              link: 'https://www.linkedin.com/in/radchukp/',
            },
          ],
          avatar: {
            id: 253,
            name: '1576064846270.jpg',
            alternativeText: '',
            caption: '',
            width: 400,
            height: 400,
            formats: {
              thumbnail: {
                ext: '.jpg',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_1576064846270_37497c0048.jpg',
                hash: 'thumbnail_1576064846270_37497c0048',
                mime: 'image/jpeg',
                name: 'thumbnail_1576064846270.jpg',
                path: null,
                size: 7.53,
                width: 156,
                height: 156,
              },
            },
            hash: '1576064846270_37497c0048',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 44.87,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/1576064846270_37497c0048.jpg',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-04-28T12:43:53.704Z',
            updated_at: '2022-04-28T12:43:53.716Z',
          },
        },
        {
          id: 118,
          name: 'Veljko Mihailovic',
          position: 'Senior Software Accounter',
          links: [
            {
              id: 258,
              title: null,
              link: 'https://www.linkedin.com/in/veljko-mihailovic/',
            },
          ],
          avatar: {
            id: 252,
            name: '1517050896302.jpg',
            alternativeText: '',
            caption: '',
            width: 140,
            height: 140,
            formats: null,
            hash: '1517050896302_330f6242ed',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 3.51,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/1517050896302_330f6242ed.jpg',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-04-28T12:43:45.466Z',
            updated_at: '2022-04-28T12:43:45.507Z',
          },
        },
        {
          id: 119,
          name: 'Josh Singh',
          position: 'Operations',
          links: [
            {
              id: 259,
              title: null,
              link: 'https://www.linkedin.com/in/joshvun-singh/',
            },
          ],
          avatar: {
            id: 259,
            name: '2022-04-28 17.22 1.png',
            alternativeText: '',
            caption: '',
            width: 510,
            height: 510,
            formats: {
              small: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/small_2022_04_28_17_22_1_457c2effd5.png',
                hash: 'small_2022_04_28_17_22_1_457c2effd5',
                mime: 'image/png',
                name: 'small_2022-04-28 17.22 1.png',
                path: null,
                size: 706.61,
                width: 500,
                height: 500,
              },
              thumbnail: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_2022_04_28_17_22_1_457c2effd5.png',
                hash: 'thumbnail_2022_04_28_17_22_1_457c2effd5',
                mime: 'image/png',
                name: 'thumbnail_2022-04-28 17.22 1.png',
                path: null,
                size: 74.99,
                width: 156,
                height: 156,
              },
            },
            hash: '2022_04_28_17_22_1_457c2effd5',
            ext: '.png',
            mime: 'image/png',
            size: 495.5,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/2022_04_28_17_22_1_457c2effd5.png',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-04-28T16:23:59.881Z',
            updated_at: '2022-04-28T16:23:59.896Z',
          },
        },
        {
          id: 120,
          name: 'Robert Young',
          position: 'Community Manager',
          links: [],
          avatar: {
            id: 258,
            name: '1631081766995.jpg',
            alternativeText: '',
            caption: '',
            width: 285,
            height: 285,
            formats: {
              thumbnail: {
                ext: '.jpg',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_1631081766995_ac2d985e9b.jpg',
                hash: 'thumbnail_1631081766995_ac2d985e9b',
                mime: 'image/jpeg',
                name: 'thumbnail_1631081766995.jpg',
                path: null,
                size: 4.84,
                width: 156,
                height: 156,
              },
            },
            hash: '1631081766995_ac2d985e9b',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 11.68,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/1631081766995_ac2d985e9b.jpg',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-04-28T16:19:59.002Z',
            updated_at: '2022-04-28T16:19:59.018Z',
          },
        },
      ],
      publicSale: {
        id: 185,
        start: '2022-05-05T11:00:00.000Z',
        end: '2022-05-06T11:00:00.000Z',
        price: '2.00',
      },
      privateSale: {
        id: 186,
        start: '2022-04-29T15:00:00.000Z',
        end: '2022-04-30T11:00:00.000Z',
        price: '2.00',
      },
      vestingPoints: [
        { id: 175, timePoint: '2023-04-06T11:00:00.000Z', percent: 100 },
      ],
      poolContract: [],
      media: {
        id: 5,
        topBanner: {
          id: 5,
          lightTheme: {
            id: 245,
            name: 'https://res.cloudinary.com/lithium/image/upload/v1651010619/v2/Group_337_qr67yz.png',
            alternativeText: '',
            caption: '',
            width: 1470,
            height: 600,
            formats: {
              large: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/large_Group_337_qr67yz_18eb647671.png',
                hash: 'large_Group_337_qr67yz_18eb647671',
                mime: 'image/png',
                name: 'large_https://res.cloudinary.com/lithium/image/upload/v1651010619/v2/Group_337_qr67yz.png',
                path: null,
                size: 668.53,
                width: 1000,
                height: 408,
              },
              small: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/small_Group_337_qr67yz_18eb647671.png',
                hash: 'small_Group_337_qr67yz_18eb647671',
                mime: 'image/png',
                name: 'small_https://res.cloudinary.com/lithium/image/upload/v1651010619/v2/Group_337_qr67yz.png',
                path: null,
                size: 175.32,
                width: 500,
                height: 204,
              },
              medium: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/medium_Group_337_qr67yz_18eb647671.png',
                hash: 'medium_Group_337_qr67yz_18eb647671',
                mime: 'image/png',
                name: 'medium_https://res.cloudinary.com/lithium/image/upload/v1651010619/v2/Group_337_qr67yz.png',
                path: null,
                size: 385.36,
                width: 750,
                height: 306,
              },
              thumbnail: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_Group_337_qr67yz_18eb647671.png',
                hash: 'thumbnail_Group_337_qr67yz_18eb647671',
                mime: 'image/png',
                name: 'thumbnail_https://res.cloudinary.com/lithium/image/upload/v1651010619/v2/Group_337_qr67yz.png',
                path: null,
                size: 42.21,
                width: 245,
                height: 100,
              },
            },
            hash: 'Group_337_qr67yz_18eb647671',
            ext: '.png',
            mime: 'image/png',
            size: 1165.02,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/Group_337_qr67yz_18eb647671.png',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-04-26T22:04:51.519Z',
            updated_at: '2022-04-26T22:04:51.548Z',
          },
          darkTheme: {
            id: 246,
            name: 'https://res.cloudinary.com/lithium/image/upload/v1651010616/v2/Screenshot_2022-04-26_at_23.01_1_dxwnyn.png',
            alternativeText: '',
            caption: '',
            width: 1470,
            height: 600,
            formats: {
              large: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/large_Screenshot_2022_04_26_at_23_01_1_dxwnyn_fc39555c45.png',
                hash: 'large_Screenshot_2022_04_26_at_23_01_1_dxwnyn_fc39555c45',
                mime: 'image/png',
                name: 'large_https://res.cloudinary.com/lithium/image/upload/v1651010616/v2/Screenshot_2022-04-26_at_23.01_1_dxwnyn.png',
                path: null,
                size: 794.18,
                width: 1000,
                height: 408,
              },
              small: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/small_Screenshot_2022_04_26_at_23_01_1_dxwnyn_fc39555c45.png',
                hash: 'small_Screenshot_2022_04_26_at_23_01_1_dxwnyn_fc39555c45',
                mime: 'image/png',
                name: 'small_https://res.cloudinary.com/lithium/image/upload/v1651010616/v2/Screenshot_2022-04-26_at_23.01_1_dxwnyn.png',
                path: null,
                size: 208.85,
                width: 500,
                height: 204,
              },
              medium: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/medium_Screenshot_2022_04_26_at_23_01_1_dxwnyn_fc39555c45.png',
                hash: 'medium_Screenshot_2022_04_26_at_23_01_1_dxwnyn_fc39555c45',
                mime: 'image/png',
                name: 'medium_https://res.cloudinary.com/lithium/image/upload/v1651010616/v2/Screenshot_2022-04-26_at_23.01_1_dxwnyn.png',
                path: null,
                size: 458.96,
                width: 750,
                height: 306,
              },
              thumbnail: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_Screenshot_2022_04_26_at_23_01_1_dxwnyn_fc39555c45.png',
                hash: 'thumbnail_Screenshot_2022_04_26_at_23_01_1_dxwnyn_fc39555c45',
                mime: 'image/png',
                name: 'thumbnail_https://res.cloudinary.com/lithium/image/upload/v1651010616/v2/Screenshot_2022-04-26_at_23.01_1_dxwnyn.png',
                path: null,
                size: 50.32,
                width: 245,
                height: 100,
              },
            },
            hash: 'Screenshot_2022_04_26_at_23_01_1_dxwnyn_fc39555c45',
            ext: '.png',
            mime: 'image/png',
            size: 1320.14,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/Screenshot_2022_04_26_at_23_01_1_dxwnyn_fc39555c45.png',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-04-26T22:05:29.652Z',
            updated_at: '2022-04-26T22:05:29.667Z',
          },
        },
        projectThumbnail: {
          id: 239,
          name: 'https://res.cloudinary.com/lithium/image/upload/v1650988987/v2/1900x700-black_3_xgwrt9.png',
          alternativeText: '',
          caption: '',
          width: 290,
          height: 180,
          formats: {
            thumbnail: {
              ext: '.png',
              url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_1900x700_black_3_xgwrt9_81221aafd2.png',
              hash: 'thumbnail_1900x700_black_3_xgwrt9_81221aafd2',
              mime: 'image/png',
              name: 'thumbnail_https://res.cloudinary.com/lithium/image/upload/v1650988987/v2/1900x700-black_3_xgwrt9.png',
              path: null,
              size: 75.22,
              width: 245,
              height: 152,
            },
          },
          hash: '1900x700_black_3_xgwrt9_81221aafd2',
          ext: '.png',
          mime: 'image/png',
          size: 67.63,
          url: 'https://lithium-production.s3.us-west-1.amazonaws.com/1900x700_black_3_xgwrt9_81221aafd2.png',
          previewUrl: null,
          provider: 'aws-s3',
          provider_metadata: null,
          created_at: '2022-04-26T21:39:12.681Z',
          updated_at: '2022-04-26T21:39:12.695Z',
        },
        featuredProjectImage: [
          {
            id: 244,
            name: 'https://res.cloudinary.com/lithium/image/upload/v1651010306/v2/Screenshot_2022-04-26_at_22.56_1_echlea.png',
            alternativeText: '',
            caption: '',
            width: 510,
            height: 510,
            formats: {
              small: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/small_Screenshot_2022_04_26_at_22_56_1_echlea_23f7edc724.png',
                hash: 'small_Screenshot_2022_04_26_at_22_56_1_echlea_23f7edc724',
                mime: 'image/png',
                name: 'small_https://res.cloudinary.com/lithium/image/upload/v1651010306/v2/Screenshot_2022-04-26_at_22.56_1_echlea.png',
                path: null,
                size: 242.21,
                width: 500,
                height: 500,
              },
              thumbnail: {
                ext: '.png',
                url: 'https://lithium-production.s3.us-west-1.amazonaws.com/thumbnail_Screenshot_2022_04_26_at_22_56_1_echlea_23f7edc724.png',
                hash: 'thumbnail_Screenshot_2022_04_26_at_22_56_1_echlea_23f7edc724',
                mime: 'image/png',
                name: 'thumbnail_https://res.cloudinary.com/lithium/image/upload/v1651010306/v2/Screenshot_2022-04-26_at_22.56_1_echlea.png',
                path: null,
                size: 32.05,
                width: 156,
                height: 156,
              },
            },
            hash: 'Screenshot_2022_04_26_at_22_56_1_echlea_23f7edc724',
            ext: '.png',
            mime: 'image/png',
            size: 161.37,
            url: 'https://lithium-production.s3.us-west-1.amazonaws.com/Screenshot_2022_04_26_at_22_56_1_echlea_23f7edc724.png',
            previewUrl: null,
            provider: 'aws-s3',
            provider_metadata: null,
            created_at: '2022-04-26T21:59:55.269Z',
            updated_at: '2022-04-26T21:59:55.283Z',
          },
        ],
        highlightsVideo: {
          id: 241,
          name: 'https://res.cloudinary.com/lithium/video/upload/v1651009211/v2/Tangible_LaunchVideo_Final_jtvh6l.mp4',
          alternativeText: '',
          caption: '',
          width: null,
          height: null,
          formats: null,
          hash: 'Tangible_Launch_Video_Final_jtvh6l_5ad3fdcbc4',
          ext: '.mp4',
          mime: 'video/mp4',
          size: 91930.92,
          url: 'https://lithium-production.s3.us-west-1.amazonaws.com/Tangible_Launch_Video_Final_jtvh6l_5ad3fdcbc4.mp4',
          previewUrl: null,
          provider: 'aws-s3',
          provider_metadata: null,
          created_at: '2022-04-26T21:41:21.260Z',
          updated_at: '2022-04-26T21:41:21.280Z',
        },
      },
      topLinks: null,
      vestingTableRow: [
        {
          id: 6,
          percent: 100,
          label:
            '4-year Vesting per block on a curve. Locked tokens earn income while being vested and are represented by an NFT, which can be immediately sold. Alternatively, tokens can be redeemed earlier by decreasing passive income benefits.',
        },
      ],
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 47,
    },
    isBusd: true,
    privateEnd: 1646499600,
    privateStart: 1646413200,
    privateTokenPrice: '2000000000000000000',
    tokenName: 'Tangible',
    tokenSymbol: 'TNGBL',
    totalSaleSupply: '2.22223e+23',
  },

  {
    cmsDetails: {
      name: 'Wizardia Public',
      initialAddress: null,
      poolAddress: '0x3E5669C31aFd4f32802Ed8f3ee76b2813360Fb6E',
      ticker: 'WZRD',
      totalSupply: '291667',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '291667',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: 292,

      about: {
        highlightsText:
          'Wizardia is a unique P2E game set in a futuristic world, enhanced with magic. The game persuades with immaculate graphics, captivating combat mechanics, and deep lore.\n- Wizardia is built upon three core principles:\n- Innovative turn-based combat\n- Player-decision driven game evolution\n- Upgrade-based character progression\nWizardia players are able to specialise many parts of the experience, including game modes, building the Wizardia metaverse, crafting items, and much more. Wizardia is a highly anticipated project, backed by some big names in the space such as AU21 Capital, Magnus Capital, and CRT Capital.',
        productText:
          'What makes Wizardia special is that both players and passive investors can earn. Investors can earn by generating passive income from revenue-generating NFTs or holding valuable in-game NFTs which can be traded to other players and investors.\nPlayers can earn from in-game interactions through two mechanisms: (1) Player to player and (2) Player to vault to player.\n(1) Players can earn by winning wagers, acquiring resources or rare NFTs, or investing time and money into their Wizards-all elements can later be re-sold. Wizardia also features a unique crafting feature, which allows you to mix different consumables/artefacts/abilities in the form of NFTs to generate new, more powerful NFTs. Naturally, you can then sell these NFTs or use them to dominate in the arena.\n(2) So-called "Arena Genesis NFTs" allow you to earn passive income from an in-game Arena that collects small fees for facilitating Player versus Player battles. Further, participation in tournaments to win in-game currency and/or $WZRD and/or valuable NFTs can earn you an income.\nAs you can see, Wizardia is not short of providing ways to earn income for both passive investors and players-all while delivering one of the most exciting games we\'ve come across in a long time.',
        problemText:
          'There are two main problems that Wizardia solves. First, there’s the obvious one: The majority of P2E games on the blockchain are kind of sh!t. They focus too much on the “earn” aspect and grossly neglect the “play” aspect. Admittedly, games don’t always need to be super developed to be captivating (think: Angry Birds, Tetris, Candy Crush, etc.), but building a simple game that is addictive—chances are probably less than one in a million.\nSecond, many games that are actually able to offer fun gameplay with great graphics lack community, which makes sense: They spend all their efforts on developing a fantastic game but completely forget to put effort into building a community. Any game without a fun and well-built community is not going to survive.',
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          'As mentioned, many games are kind of sh!t. Make no mistake, Wizardia really is not only a “slightly better than sh!t” game; it’s playing in its own league. Wizardia impresses with extremely fun gameplay and insane graphics, leaving most P2E games on the blockchain in the dust.\nIn terms of building a community, Wizardia understood the assignment and pushed heavy to engage and captivate gamers early on. Wizardia has built impressive hype (deservedly so) around its product, and we can’t wait to see its community grow!',
        shortBio: null,
        links: [],
        logo: {
          url: 'https://lithium-production.s3.us-west-1.amazonaws.com/g9_U2rh_Qv_400x400_c0546df48f.jpg',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2022-03-18T18:00:00.000Z',
        end: '2022-03-19T18:00:00.000Z',
        price: 0.12,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.12,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649775793/v2/Wizardia-Wizards_qd9etd_1_wvgwie.png',
          },
          darkTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649775793/v2/Wizardia-Wizards_qd9etd_1_wvgwie.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168906/v2/510x510_Wizardia-symbol-white_c7molr.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168906/v2/290x180_black_BG_oqs3vd.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 61,
    },
    isBusd: true,
    privateEnd: 1647712800,
    privateStart: 1647626400,
    privateTokenPrice: '120000000000000000',
    tokenName: 'Wizardia Public',
    tokenSymbol: 'WZRD',
    totalSaleSupply: '2.91667e+23',
  },
  {
    cmsDetails: {
      name: 'Wizardia Private',
      initialAddress: null,
      poolAddress: '0xd25e07675c1fdc6dec01bc29994a7574967fd5aa',
      ticker: 'WZRD',
      totalSupply: '625000',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '625000',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: 438,
      about: {
        highlightsText:
          'Wizardia is a unique P2E game set in a futuristic world, enhanced with magic. The game persuades with immaculate graphics, captivating combat mechanics, and deep lore.\n- Wizardia is built upon three core principles:\n- Innovative turn-based combat\n- Player-decision driven game evolution\n- Upgrade-based character progression\nWizardia players are able to specialise many parts of the experience, including game modes, building the Wizardia metaverse, crafting items, and much more. Wizardia is a highly anticipated project, backed by some big names in the space such as AU21 Capital, Magnus Capital, and CRT Capital.',
        productText:
          'What makes Wizardia special is that both players and passive investors can earn. Investors can earn by generating passive income from revenue-generating NFTs or holding valuable in-game NFTs which can be traded to other players and investors.\nPlayers can earn from in-game interactions through two mechanisms: (1) Player to player and (2) Player to vault to player.\n(1) Players can earn by winning wagers, acquiring resources or rare NFTs, or investing time and money into their Wizards-all elements can later be re-sold. Wizardia also features a unique crafting feature, which allows you to mix different consumables/artefacts/abilities in the form of NFTs to generate new, more powerful NFTs. Naturally, you can then sell these NFTs or use them to dominate in the arena.\n(2) So-called "Arena Genesis NFTs" allow you to earn passive income from an in-game Arena that collects small fees for facilitating Player versus Player battles. Further, participation in tournaments to win in-game currency and/or $WZRD and/or valuable NFTs can earn you an income.\nAs you can see, Wizardia is not short of providing ways to earn income for both passive investors and players-all while delivering one of the most exciting games we\'ve come across in a long time.',
        problemText:
          'There are two main problems that Wizardia solves. First, there’s the obvious one: The majority of P2E games on the blockchain are kind of sh!t. They focus too much on the “earn” aspect and grossly neglect the “play” aspect. Admittedly, games don’t always need to be super developed to be captivating (think: Angry Birds, Tetris, Candy Crush, etc.), but building a simple game that is addictive—chances are probably less than one in a million.\nSecond, many games that are actually able to offer fun gameplay with great graphics lack community, which makes sense: They spend all their efforts on developing a fantastic game but completely forget to put effort into building a community. Any game without a fun and well-built community is not going to survive.',
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          'As mentioned, many games are kind of sh!t. Make no mistake, Wizardia really is not only a “slightly better than sh!t” game; it’s playing in its own league. Wizardia impresses with extremely fun gameplay and insane graphics, leaving most P2E games on the blockchain in the dust.\nIn terms of building a community, Wizardia understood the assignment and pushed heavy to engage and captivate gamers early on. Wizardia has built impressive hype (deservedly so) around its product, and we can’t wait to see its community grow!',
        shortBio: null,
        links: [],
        logo: {
          url: 'https://lithium-production.s3.us-west-1.amazonaws.com/g9_U2rh_Qv_400x400_c0546df48f.jpg',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2022-03-15T18:00:00.000Z',
        end: '2022-03-16T18:00:00.000Z',
        price: 0.08,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.12,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649775793/v2/Wizardia-Wizards_qd9etd_1_wvgwie.png',
          },
          darkTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649775793/v2/Wizardia-Wizards_qd9etd_1_wvgwie.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168906/v2/510x510_Wizardia-symbol-white_c7molr.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168906/v2/290x180_black_BG_oqs3vd.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 89.9,
    },
    isBusd: true,
    privateEnd: 1647453600,
    privateStart: 1647367200,
    privateTokenPrice: '80000000000000000',
    tokenName: 'Wizardia Private',
    tokenSymbol: 'WZRD',
    totalSaleSupply: '6.25e+23',
  },
  {
    cmsDetails: {
      name: 'Toyoverse Public',
      initialAddress: null,
      poolAddress: '0x753ebfad974246e349f1d8d0a17980bb44bea6cb',
      ticker: 'TOYO',
      totalSupply: '500000',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      crossChainLink: 'matic',
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '500000',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: null,
      about: {
        highlightsText:
          "Toyo, the brainchild of Lucid Dreams Studio debuts its token sale on Seedify and ZAP Ventures this February! To date the project has run two successful NFT sales releasing some shit hot NFT's (if we say so ourselves) and raising over $550k in the process. The team, based in Dubai, has some serious creative minds in its arsenal along with some seriously cool tech. Toyo is primed to take more than just the metaverse by storm.\n- Action Figue multi Metaverse\n- Customisable Characters, Parts and Attachments, Land Ownership\n- Shared Property means your NFT's generate royalties\n- Multimedia Franchaise (Cards, Anime Series, Comics, etc)\nP2E is undeniably the hype across the crypto space at the minute but with the outrageous number of copy and paste projects the over-saturation is fast becoming monotonous. Toyo really breathes fresh air into this sector where the potential for innovation is, in theory, limitless. The sheer creativity that powers the concept of Toyo is something that we cannot wait to introduce to the market via ZAP.",
        productText:
          "\nWhere do we start? As we said Toyo doesn't replicate the now seemingly standard P2E model. The product is diverse, exciting, granular, and expansive. The elements of the overall product join together seamlessly giving fans of gaming, action, P2E, anime and much more an universe with ever growing possibilities to explore.\nThe core game offering will allow users to purchase and trade NFT's customisable to the 10th degree and battle them in exciting colourful arenas. The characters have 10 customisable features, and their stats improve through training and participation. The higher level your Toyo, the higher its earnings in the arenas! Running 9 Genesis drops, with 2 completed, there is still time to get your hands on these unique NFT's.\nFurther customisation is achieved through purchasing attachments and new parts through in game airdrops and rewards. The depth of customisation is enough to keep even the shortest attention span glued for hours. As expected there will be exciting land ownership opportunities including training camps, arenas and more options being released in the not too distant future.\nAbove and beyond the NFT ownership and customisation Toyo will be introducing an excellent addition of products to power this expansive universe. Collector cards, Anime Series, Comics, IRL Toys, and further licensing opportunities will combine to deliver a truly one of a kind P2E experience for its users and holders.",
        problemText:
          '\nAs with any P2E gaming concept the problem posed by its traditional counterparts largely lies in ownership. Across web 2.0 and traditional gaming there lacked incentives and ownership concepts for players. In recent times game studios attempted to address this lack of reward through structures such as the loot crate, giving players the opportunity to exchange a consumable virtual item for further random virtual items (or loot).\nThe problem with this, is that beyond the realm of the game itself the player does not physically own any of this redeemed loot or in game items. Additionally, we are not able to express our authenticity, we all have very cool online usernames and profile pictures; but there is no immersive audiovisual component that does justice to our individuality.',
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          "\nBy definition the P2E concept, rewards players for their time playing the game and interacting with the ecosystem. Players take ownership through in game NFT's, and earn rewards through the in-game currency or tokens which can be used in-game or traded on exchanges. Whilst this model is incredibly innovative and still in its infancy, the number of P2E projects now offering the same copy and paste ownership solution is outstanding. Toyo go one step further in offering a genuine solution to the problem posed by traditional gaming, demonstrating their commitment to both community and gaming.\nThe truly innovative concept of delivering royalties to its holders is something we have rarely seen in a solution so inspirational. The NFT holders of Toyo will forever have a percentage of future revenues of the project where their characters are featured both online and offline. In practice, should your NFT character feature in the anime series you will receive a proportional share of the profits made by the licensing deal around that series. If your character features in the comic series you will get a share of the revenue generated by that comic series. If your character has a physical toy collectible made… you get the picture.\nThis incredibly inclusive community model is exactly what decentralisation is all about. Toyo have measured the balance of creativity, technology, and community perfectly and if you know anything about ZAP this is exactly what we're here to discover.",
        shortBio: null,
        links: [],
        logo: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1643296219/toyo_logo_PROFILE_SQUARE_rnjqnz.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2022-03-07T18:00:00.000Z',
        end: '2022-03-08T18:00:00.000Z',
        price: 0.3,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.3,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://lithium-launchpad-cms.s3.eu-west-2.amazonaws.com/demo_bg_pools_page_e250ef5e55.png',
          },
          darkTheme: {
            url: 'https://lithium-launchpad-cms.s3.eu-west-2.amazonaws.com/demo_bg_pools_page_e250ef5e55.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168910/v2/toy_gyzqbg.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168910/v2/toy510x510_cyrqfi.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 54.8,
    },
    isBusd: true,
    privateEnd: 1646762400,
    privateStart: 1646676000,
    privateTokenPrice: '300000000000000000',
    tokenName: 'Toyoverse Public',
    tokenSymbol: 'TOYO',
    totalSaleSupply: '5e+23',
  },
  {
    cmsDetails: {
      name: 'Toyoverse Private',
      initialAddress: null,
      poolAddress: '0xb88761de23fbbfbcbeea92104eadea1b7913304e',
      ticker: 'TOYO',
      totalSupply: '222223',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      crossChainLink: 'matic',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '222223',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: null,
      about: {
        highlightsText:
          "Toyo, the brainchild of Lucid Dreams Studio debuts its token sale on Seedify and ZAP Ventures this February! To date the project has run two successful NFT sales releasing some shit hot NFT's (if we say so ourselves) and raising over $550k in the process. The team, based in Dubai, has some serious creative minds in its arsenal along with some seriously cool tech. Toyo is primed to take more than just the metaverse by storm.\n- Action Figue multi Metaverse\n- Customisable Characters, Parts and Attachments, Land Ownership\n- Shared Property means your NFT's generate royalties\n- Multimedia Franchaise (Cards, Anime Series, Comics, etc)\nP2E is undeniably the hype across the crypto space at the minute but with the outrageous number of copy and paste projects the over-saturation is fast becoming monotonous. Toyo really breathes fresh air into this sector where the potential for innovation is, in theory, limitless. The sheer creativity that powers the concept of Toyo is something that we cannot wait to introduce to the market via ZAP.",
        productText:
          "\nWhere do we start? As we said Toyo doesn't replicate the now seemingly standard P2E model. The product is diverse, exciting, granular, and expansive. The elements of the overall product join together seamlessly giving fans of gaming, action, P2E, anime and much more an universe with ever growing possibilities to explore.\nThe core game offering will allow users to purchase and trade NFT's customisable to the 10th degree and battle them in exciting colourful arenas. The characters have 10 customisable features, and their stats improve through training and participation. The higher level your Toyo, the higher its earnings in the arenas! Running 9 Genesis drops, with 2 completed, there is still time to get your hands on these unique NFT's.\nFurther customisation is achieved through purchasing attachments and new parts through in game airdrops and rewards. The depth of customisation is enough to keep even the shortest attention span glued for hours. As expected there will be exciting land ownership opportunities including training camps, arenas and more options being released in the not too distant future.\nAbove and beyond the NFT ownership and customisation Toyo will be introducing an excellent addition of products to power this expansive universe. Collector cards, Anime Series, Comics, IRL Toys, and further licensing opportunities will combine to deliver a truly one of a kind P2E experience for its users and holders.",
        problemText:
          '\nAs with any P2E gaming concept the problem posed by its traditional counterparts largely lies in ownership. Across web 2.0 and traditional gaming there lacked incentives and ownership concepts for players. In recent times game studios attempted to address this lack of reward through structures such as the loot crate, giving players the opportunity to exchange a consumable virtual item for further random virtual items (or loot).\nThe problem with this, is that beyond the realm of the game itself the player does not physically own any of this redeemed loot or in game items. Additionally, we are not able to express our authenticity, we all have very cool online usernames and profile pictures; but there is no immersive audiovisual component that does justice to our individuality.',
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          "\nBy definition the P2E concept, rewards players for their time playing the game and interacting with the ecosystem. Players take ownership through in game NFT's, and earn rewards through the in-game currency or tokens which can be used in-game or traded on exchanges. Whilst this model is incredibly innovative and still in its infancy, the number of P2E projects now offering the same copy and paste ownership solution is outstanding. Toyo go one step further in offering a genuine solution to the problem posed by traditional gaming, demonstrating their commitment to both community and gaming.\nThe truly innovative concept of delivering royalties to its holders is something we have rarely seen in a solution so inspirational. The NFT holders of Toyo will forever have a percentage of future revenues of the project where their characters are featured both online and offline. In practice, should your NFT character feature in the anime series you will receive a proportional share of the profits made by the licensing deal around that series. If your character features in the comic series you will get a share of the revenue generated by that comic series. If your character has a physical toy collectible made… you get the picture.\nThis incredibly inclusive community model is exactly what decentralisation is all about. Toyo have measured the balance of creativity, technology, and community perfectly and if you know anything about ZAP this is exactly what we're here to discover.",
        shortBio: null,
        links: [],
        logo: {
          url: 'https://lithium-production.s3.us-west-1.amazonaws.com/toyo_logo_PROFILE_SQUARE_rnjqnz_a0c1ade4f8.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2022-03-04T17:00:00.000Z',
        end: '2022-03-05T17:00:00.000Z',
        price: 0.225,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.3,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://lithium-launchpad-cms.s3.eu-west-2.amazonaws.com/demo_bg_pools_page_e250ef5e55.png',
          },
          darkTheme: {
            url: 'https://lithium-launchpad-cms.s3.eu-west-2.amazonaws.com/demo_bg_pools_page_e250ef5e55.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168910/v2/toy_gyzqbg.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168910/v2/toy510x510_cyrqfi.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 302.6,
    },
    isBusd: true,
    privateEnd: 1646499600,
    privateStart: 1646413200,
    privateTokenPrice: '225000000000000000',
    tokenName: 'Toyoverse Private',
    tokenSymbol: 'TOYO',
    totalSaleSupply: '2.22223e+23',
  },
  {
    cmsDetails: {
      name: 'BetSwirl',
      initialAddress: null,
      poolAddress: '0x02ad2b272bbd41f47a6cc39d7e7ae85d089354b4',
      ticker: 'BETS',
      totalSupply: '250000000',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      crossChainLink: 'matic',
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '250000000',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: null,
      about: {
        highlightsText:
          '\nBetSwirl aims to bring provably fair gambling to Ethereum-compatible blockchains. Their first target is the currently booming Polygon, which is still in its infancy state and gathers main newcomers in the blockchain world. The rise of yield farming and speculation around ERC-20 deflationary tokens brought lots of money, but also increased risks for users having to deal with malevolent developers and asymmetry of information.\nHence, the market seems ripe for a transparent, straightforward, and clean gambling dApp taking advantage of the technical possibilities of Polygon while being safe for its users looking to play and earn money this way.',
        productText:
          "\nEven though more and more users gather in the blockchain multiverse, the infrastructure for new dApps is still sometimes lacking, as big players from Ethereum concentrate on their original market. BetSwirl's development effort aims to be as easy as possible to deploy on other blockchains, allowing them to address untapped markets quickly and position themselves before the competition does. Avax C-Chain will be their next target.\nBetswirl is already ready to welcome players with two first games playable on testnet. They will soon be available on mainnet and joined by many other games; stay tuned!",
        problemText: null,
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText: null,
        shortBio: null,
        links: [],
        logo: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1644594945/icon_lwdw4s.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2022-03-02T17:00:00.000Z',
        end: '2022-03-03T17:00:00.000Z',
        price: 0.00016,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.0002,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1650031462/v2/Group_328_iqugfm.png',
          },
          darkTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649780219/v2/1470x600_rrashe_kmgqf7.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168907/v2/290x180_sfauhr.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168907/v2/510x510_x4zgvc.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 96.1,
    },
    isBusd: true,
    privateEnd: 1646326800,
    privateStart: 1646240400,
    privateTokenPrice: '160000000000000',
    tokenName: 'BetSwirl',
    tokenSymbol: 'BETS',
    totalSaleSupply: '2.5e+26',
  },
  {
    cmsDetails: {
      name: 'Mechachain',
      initialAddress: null,
      poolAddress: '0x48ba8db1e09e3133179da14bb0a35e03503be01a',
      ticker: 'MECHA',
      totalSupply: '214286',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      crossChainLink: 'matic',
      mainNet: null,
      totalSaleSupply: '214286',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: 20,
      about: {
        highlightsText:
          'Robots. Exchangeable Parts. Play to Earn. What’s not to like? If your childhood was anything like ours (and maybe we are showing our age here) you probably played the game Beyblades. Beyblades were incredibly addictive, you would try and build your ultimate weapon, you’d meet up with a couple of friends pull out your arena, pull the cord, and see who won.\nThis may seem like a childish analogy, but it’s interesting to dissect the fundamentals of what makes a good game. Firstly, with Beyblades — you felt a sense of ownership. Your Beyblade was yours, you could customise it as you like, you could tweak its parts, experiment with different ones and see what works for you. Because of this ownership, there was a certain amount of bragging right that went with the toy, just like the kid on the playground who had the best conkers, you could rub it into your oppositions face that you were the king, you knew what was good, and they didn’t have a clue.\nUnfortunately, the ownership element of play has been lost in the digital age. Our avatars, characters, weapons, loot and anything else we acquire through the world of online gaming don’t belong to us, they belong to the video game producer. Mechachain aim to bring the aspects of building fun, addictive advanced technology unlocks, while still retaining the play-to-earn elements we’ve come to know and love with Web3 gaming projects.\n- Fully customisable, NFT-based P2E fighting game\n- Incredible working product, built around their community\n- Rewards skilled players, and those that contribute most to the ecosystem\n- Innovative building of revenue streams through planets and virtual land',
        productText:
          'One thing we love about the Mechachain project is that it’s been built — from the ground up — with it’s community. At every stage of development those who are going to be using the product have had their say, helping shape their MVP into one of the best we’ve seen.\nFor their beta version, Mechachain have focused on a few core features:\n- Customization of your Mecha in the workshop\n- Mecha battles\n- NFT marketplace\n- Galactic conquest on the MechaChain console\nThe workshop allows the combination of 3D NFT’s to create your ultimate mecha. All these NFTs are have been meticulously crafted by a team of 3D artists. Each of the 8 NFTs that make up a mecha, affect the statistics such as the attack and defence. The mecha battles are skill-based. The stats of the mecha you use will of course influence the outcome, but it’s completely possible for a mecha of less favourable stats to beat a higher-ranked opponent. You need to have skill to win! Winning battles will result in rewards being dropped, rewards that will generate you real income.\nAll NFTs that make up a mecha will be freely tradeable on the NFT marketplace. Holders of potentially precious items will be able to profit from being patient, while gamers who yield rewards from their victories will be able to sell their loot.',
        problemText:
          '\nThe key problem Mechachain exist to solve is to help skilled gamers capitalise on the hours they spend mastering their craft. Every day thousands of hours are pushed into games like world of warcraft, Fortnite and others. Unless you are a streamer, or in the top echelon of gamers who can win competitions it’s pretty much impossible to earn a living (or even some walking around money) gaming.\nIt’s easy to accept this as a given ‘well it’s just a game, it shouldn’t need to produce you income, you do it for fun’. At ZAP, we think this is a rather backward way of looking at gaming. At the end of the day, gamers put in energy and skill to produce an output that somebody is willing to pay for, this is literally the definition of productivity.\nWe are sure that the play-to-earn space will be the quickest growing element of crypto, and ultimately will be what opens it up to the masses.',
        businessModalText:
          'The complete business model of Mechachain is too complex to cover in this summary article, instead, we recommend checking https://whitepaper.mechachain.io/tokenomia on their whitepaper.',
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText: null,
        shortBio: null,
        links: [],
        logo: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1642433915/image-2_g68myw.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2022-02-22T18:00:00.000Z',
        end: '2022-02-23T18:00:00.000Z',
        price: 0.7,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.7,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168908/v2/Copie_de_assimilee_city_LD_1_v9oygk.png',
          },
          darkTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168908/v2/Copie_de_assimilee_city_LD_1_v9oygk.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168907/v2/Copie_de_pure_gene_city_LD_1_sltkfi.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168907/v2/20211124_Bannieres_Fb_3_2_1_ailxmm.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 39.7,
    },
    isBusd: true,
    privateEnd: 1645639200,
    privateStart: 1645552800,
    privateTokenPrice: '700000000000000000',
    tokenName: 'Mechachain',
    tokenSymbol: 'MECHA',
    totalSaleSupply: '2.14286e+23',
  },
  {
    cmsDetails: {
      name: 'Legion Network',
      initialAddress: null,
      poolAddress: '0x384ed1cec9f436e38d2ebf8568e15089e7fff3d0',
      ticker: 'LGX',
      totalSupply: '4000000',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '4000000',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: null,
      about: {
        highlightsText:
          'Blockchain. Web3. Crypto. Decentralisation. These terms are becoming increasingly common but it is not always clear or apparent what they mean, what they do, and how they are relevant to you. Well, no more. Legion Network are delivering a revolutionary new blockchain ecosystem housed in on super application.\nAlready widely covered in notable publications Legion Network is solving the problem and complexity of access to crypto driven services on their platform easily accessed and understood by stock boomers and early crypto adopters alike. The simplicity in the delivery is an incredible feat considering what the project is actually delivering.\n- Collaborative NFT Marketplace\n- Metaverse\n- Play to Earn (P2E)\n- Watch to Earn (W2E)\n- Innovative SaaS products',
        productText:
          'The product itself is housed in one decentralised ‘Super App’ providing easy and simple access to the suite of services provided by Legion Network. The wider Legion ecosystem is categorised into 5 distinct products each delivering considerable value to its users.\n### Bluemoon\nBluemoon is as ambitious as it is straightforward. Solving the existing problems found in NFT marketplaces it also offers users a host of innovations. Bluemoon will allow artists to collaborate with brands as well as the community. As well as buying and selling you can also create, compare, swap and rent NFTs.\n### Arcadia\nThink mainstream P2E adoption. Think Steam, but you get paid. Not only will Arcadia have a host of P2E games for gamers to get stuck into, earning LGX in exchange for their time and efforts, the platform will provide daily challenges also paying out rewards and prizes.\n### Empower\nOne of the core principles of ZAP is education and Empower might be one of the smoothest applications of this ethos we have seen in the space. Throwing the traditional revenue model used by the likes of YouTube on its head, Legion offers its users not only the opportunity to learn, but get PAID whilst doing it. Empowering both the students and the teachers we are huge fans of this innovation, and so should you be.\n### Rewards\nWith Legion Rewards you will be able enter a weekly giveaway to win prizes by completing different tasks every week. This platform not only centralises where users have to go to earn rewards and discover projects, but gives legitimate projects an engaged and interested user base already using the Legion Network platform.\n### Bizpad\nIt wouldn’t be Legion Network without thinking of everything, and that is where Bizpad comes in to play! Legion’s Bizpad will provide a one stop shop for software that is crucial to delivering value across Web3.',
        problemText:
          'Web3 is often an incredibly complex and distributed environment. Whilst that has its advantages, especially for us early adopters and self confessed nerds, it does not help to drive adoption. With the ever growing number of chains, centralised, decentralised, hybrid and more, who’s strengths and weaknesses offset eachother for privacy, or throughput or any other number of factors, crypto is becoming increasingly diverse and distributed.',
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          'Legion Network intends to create a super blockchain- based ecosystem that will connect creators, large brands, influencers, entrepreneurs and help them to unleash their potential via cutting- edge technologies.',
        shortBio: null,
        links: [],
        logo: {
          url: 'https://lithium-launchpad-cms.s3.eu-west-2.amazonaws.com/uploads/Legion_Token_200x200_d03e480859.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2022-02-17T17:00:00.000Z',
        end: '2022-02-18T17:00:00.000Z',
        price: 0.075,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.15,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1650031462/v2/Group_329_t2c8ft.png',
          },
          darkTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649780432/v2/Banner_5_1_eqa3jb.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168909/v2/leg290x180_yh83al.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168908/v2/leg510x510_vx97di.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 64.4,
    },
    isBusd: true,
    privateEnd: 1645203600,
    privateStart: 1645117200,
    privateTokenPrice: '75000000000000000',
    tokenName: 'Legion Network',
    tokenSymbol: 'LGX',
    totalSaleSupply: '4e+24',
  },
  {
    cmsDetails: {
      name: 'DeFi Yield',
      initialAddress: null,
      poolAddress: '0xfa08bf239ff7da5240c7780382694bac2049b90a',
      ticker: 'DEFI',
      totalSupply: '500000',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      crossChainLink: 'matic',
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '500000',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: null,
      about: {
        highlightsText:
          "DeFi can be a confusing place. For non-crypto natives the world of private keys, non custodial wallets, DEX's and often non-intuitive UX's it can be incredibly off-putting and arguably one of the biggest barriers to entry for retail investors. At ZAP we're huge fans of simplification, education, and appealing to non-crypto natives. When we began to talking to DeFiYield and saw what they were building it made total sense that ZAP should promote and support their mission.\n- Suite of comprehensive DeFi products\n- SDK's for developers in the ecosystem\n- 18 Chains integrated with more coming\n- Free educational material\n- Industry heavyweight investors and advisors\nWhen it comes to protecting, educating and simplification for the retail investor we get excited. DeFi Yield App's extensive ecosystem addresses some of the systemic and deep rooted issues in crypto, with an unwavering focus on the DeFi landscape. Breaking down barriers to entry, and improving the user experience and safety of retail investors has clearly grabbed the attention, capital, and resources of big investors and here's why…",
        productText:
          "DeFiYield App are building a one stop shop for DeFi needs. Appealing to both investors and developers DeFiYield App are deploying a comprehensive suite of tools to make life in DeFi simpler, safer, and sexy.\nSplit into three primary categories, the team have thought about the prominent and more underlying issues facing investors and users within the DeFi space. \nMANAGE Here, users will be able to gain a complete overview of their DeFi investments, from held tokens, staking and yield farming, and NFT's. With user friendly charts, statistics, and other qualitative and quantitive information this area of the platform is going to make life easier for every HODLer and active trader alike. \nWith this just being an early iteration of the product it's fair to say that users can expect a lot more value to be added through future product improvements and amendments.\nTOOLKIT With seemingly a never ending torrent of malicious projects and constant coverage of eye-wateringly large hacks DeFi can be a difficult landscape to try and navigate. DeFi Yield App are making this easier for investors with easy to use tools that can give accurate and real time information on various aspects of projects within the space. \nIs liquidity a concern? Has the developer got a history of rug pulls? What's my exposure to Impermanent Loss? The DeFiYield App Toolkit is here to answer these questions, quickly, efficiently and definitively.",
        problemText:
          "DeFi beyond its core userbase, often people working in tech or finance, as well as early adopters from regions such as South East Asia, struggles to appeal to a wider audience. The concept of Liquidity Pools, Impermanent Loss, APY's, extreme market volatility, and many other things make DeFi not only largely inaccessible to the vast majority of people, but hugely unappealing. Sitting here, DeFi users such as us may not understand people's desire to earn 1% a year in an ISA when 20% APY's exist on stable coins across the DeFi sphere. For the reasons mentioned previously, the typical users of ISA's, often cash rich and risk adverse middle aged professionals, pensioners and other demographics, are instantly turned off from DeFi protocols and financial instruments.",
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          'The team behind DeFiYield App have taken a direct and objective approach to the problems presented by DeFi and faced by its users. With slick and intuitive UI and UX, users can seamlessly navigate the platform to further understand their portfolio, risks associated with it, and many other things that typically require more than one platform and quite often counter intuitive UX.\nBy bridging the gap between more traditional FinTech platforms and the typically more complex DeFi counterparts DeFiYield App begins to appeal to a more mainstream audience. Suddenly, innovative DeFi products and platforms become easily accessible, understandable and useable for non-crypto natives. As crypto begins to creep more gradually into the mainstream this perfectly positions DeFiYield App to be the preeminent platform for portfolio and risk management for both investors and developers.',
        shortBio: null,
        links: [],
        logo: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1644252190/Blue_favicon_cjqycl.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2022-02-14T18:00:00.000Z',
        end: '2022-02-15T18:00:00.000Z',
        price: 0.24,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.31,
      },
      vestingPoints: [],
      media: {
        topBanner: null,
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168908/v2/dy290x180_jdukcs.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168908/v2/dy510x510_gsqabr.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 102.1,
    },
    isBusd: true,
    privateEnd: 1644948000,
    privateStart: 1644861600,
    privateTokenPrice: '240000000000000000',
    tokenName: 'DeFi Yield',
    tokenSymbol: 'DEFI',
    totalSaleSupply: '5e+23',
  },
  {
    cmsDetails: {
      name: 'Teneo',
      initialAddress: null,
      poolAddress: '0x9c9a6941ea93ef1a228d776aa1dac4a2d937cc4d',
      ticker: 'TEN',
      totalSupply: '1052632',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '1052632',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: 15,
      about: {
        highlightsText:
          'DeFi has provided easier access and lower barriers to entry to innovative and advanced financial instruments for the average investor. With traditional finance being overwhelmingly reserved for high net worth individuals it is no wonder that DeFi has experienced a significant surge in TVL, user adoption and transaction volume in such a short space of time. From the likes of Bancor to AAVE these innovative protocols have been empowering traders, investors, lenders, and borrowers alike to make a return despite their differing risk appetites and knowledge of the space.\nTeneo Finance introduces an innovative DeFi protocol allowing traders to successfully execute arbitrage trades within its ecosystem, holders to mitigate risks against the downside whilst increasing their exposure to the upside, and lenders a return from providing the protocol liquidity.\n- Sustainable Liquidity Farming\n- Internalising Arbitrage\n- Innovative Reflow mechanisms',
        productText:
          'Teneo are bringing a platform of empowerment to allow users in the DeFi space to broaden their portfolio and make the most of the value driven Teneo ecosystem. With incentives for various user profiles Teneo is delivering an intuitive suite of financial instruments geared towards rewarding people through various mechanisms.\nLiquidity Providers Often outlandish and unstable APY’s are seen in droves across the DeFi space. Whilst these figures often look eyewateringly attractive, you have to wonder how they can be sustained let alone be a legitimate offering. As one of the priority targets for hackers, Liquidity Pools can be easy pickings for skilled malicious actors looking for a quick and rather sizeable win. These LP’s offer silly APY’s, and often provide equally silly assurance in the competency of their audits. Teneo Finance has been audited by Certik, Zokyo, and Hacken at various stages of development giving the protocol a triple seal of approval, and investors that added reassurance.\nArbitrage Traders Thesystem is designed to open triangular arbitrage opportunities and increase the spread between tokens and their ten-token counterparts as liquidity pools accumulate reflows. Arbitrage removes value from LP’s, thus the Teneo protocol will act on those arbitrage opportunities and redistribute value to Teneo Hodlers while profiting ten-tokens owners through fees incurred during the process.\nHolders Holding the TenETH token, or whatever other TenPEG it may be, for example TenBNB, holders will be able to reduce their exposure to market downtrends and increase their exposure as the price shifts upwards. This incentivises people who do not trade or provide liquidity to invest in Teneo regardless.',
        problemText:
          'Traditional finance has significant barriers to entry for the average investor including things such as Emotion Lead Investing, Lack of Knowledge, High Capital Requirements, Small Picture Syndrome and many more. DeFi has granted access for millions of investors that potentially would not have typically used or benefited from its traditional counterpart. Whilst the capitalisation of traditional markets is a staggering sum, the sheer number of investors, borrowers, and lenders that only have access to substandard financial products is numerous.\nThis resulting capital was either laying dormant, deployed inefficiently, and/or making menial returns in the process. As DeFi burst on to the scene, people began to wake up.',
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          'Teneo Finance offers investors of all profile and risk appetite innovative tools to utilise in which to grow their capital whether it be from lending, trading or simply holding. If you have slightly more risk appetite than investing in a stocks and shares ISA, holding your portfolio of assets in the TenPEG format can supercharge even the most basic investment principle of the hodl. Reduce your exposure to downward market movements, and benefit significantly more on upward momentum. With low barrier to entry and products aimed at differing investor profiles Teneo is comprehensive and innovative in its first DeFi offering.',
        shortBio: null,
        links: [],
        logo: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1643821225/teneo_ckfksc.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2022-02-10T18:00:00.000Z',
        end: '2022-02-11T18:00:00.000Z',
        price: 0.095,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.095,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649778024/v2/ten1470x600_yj54kh_uv6mpb.png',
          },
          darkTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649968693/v2/Screenshot_2022-04-14_at_21.36_1_i9kwtn.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168909/v2/ten290x180_o57ogv.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168909/v2/ten510x510_d5ksax.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 129.8,
    },
    isBusd: true,
    privateEnd: 1644602400,
    privateStart: 1644516000,
    privateTokenPrice: '95000000000000000',
    tokenName: 'Teneo',
    tokenSymbol: 'TEN',
    totalSaleSupply: '1.052632e+24',
  },
  {
    cmsDetails: {
      name: 'Vault Hill',
      initialAddress: null,
      poolAddress: '0xD19053FCCD41047FE10C6E9901Bd668431D8cec7',
      ticker: 'VHC',
      totalSupply: '8000000',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '8000000',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: null,
      crossChainLink: 'matic',
      about: {
        highlightsText:
          'Vault Hill aims to create a Metaverse called Vault Hill City (VHC) — a collection of virtual shared space including the sum of all virtual worlds and the Internet. In VHC, users can interact with computer-generated imagery (CGI) and other users. EXtended reality (XR), a mix of virtual reality, augmented reality, and mixed reality is used to create real enhancements of human experiences whilst leveraging the power of blockchain, artificial intelligence and cloud computing technologies.\n- Expansive human instinct themed metaverse environment to build and explore with virtual landIn-house market place to trade and exchange NFTs\n- “NO CODE” builder tool for content creators and virtual land owners\n- In-house market place to trade and exchange NFTs with life-long perpetual royalties\n- Expansive and ambition roadmap with a killer team to execute on the vision',
        productText:
          'Their product has been designed to have 7 unique districts, all with different features to create a truly dynamic and unique experience for participants and players.\n#### District Alpha\nExperiences in District Alpha might involve taking an interactive course, attending a seminar, participating in a workshop, or having a fully immersive adventure focused around learning a specific skill or subject.\n#### District Beta\nExperiences here are abundant and enjoyable, like dancing, social gatherings, happy hours, concerts, group events and more.\n#### District Delta\nNo humanistic metaverse would truly be complete without the possibility for love, something that abounds in District Delta. Experiences here, like speed dating avatar-to-avatar, might save you a lot of time wasted kissing frogs in the real world (Who knows — Tom might finally find a girlfriend?)\n#### District Pi\nWhile the possibilities are endless, some experiences you might encounter here are empathy-based understanding sessions. For instance, actually feel what it’s like to be elderly or to live under completely different conditions. On the other hand, you might spend your time here rooting out what it means to be your best and truest self.\n#### District Omega\nTake an individual or group class or even work with personal trainers to burn calories in the digital world that are actually being burnt in the physical world.\n#### District Sigma\nExplore big ideas and collaborate with others to make your greatest dreams come to life in District Sigma. In this district, if you can dream it, you can build it.\n#### District Kappa\nDistrict Kappa, all are welcome to attend group events and social gatherings that help to form friendships and a real-world support system.\nReally the possibilities to explore, build, play and create really are endless. Vault hill has an insanely ambitious roadmap with both near term and longer run deliverables. We absolutely LOVE the vision which is why we wanted to be involved in launching the projects to the masses.',
        problemText:
          'The key challenges in the space are the lack of intuitive and rich user experience for users and substandard in-built metaverse developer applications for content developers. Many XR applications make us feel less connected, devoid of real world emotions and lack a rich user experience. In addition to this, the current problems may be split into two main categories:\n#### For Users\n- Lack of intuitive and rich user experience\n- Barrier to participation due to access to XR hardware and high costs of acquisition\n- Lack of choice and open/closed governance\n- Data privacy and sovereignty\n#### For Content Creators\n- Inability to maximise content creation reward\n- Lack of content ownership and lifelong royaltiesŠ\n- Poor in-built software application in current metaverseŠ\n- Inadequate high^quality sustainable content',
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          'Vault Hill aims to build an extended reality metaverse that makes us feel a bit more human every time we visit. A limitless world with a guiding principle to enhance the human experience.\nThey are building a constructive metaverse which simplifies creator tools with dynamic user interfaces, which increases adoption rates and integrates both AI and blockchain technology to revolutionise the human experience. At the same time, the in house marketplace enables content creators to monetise their work and have full ownership of creations.',
        shortBio: null,
        links: [],
        logo: {
          url: 'https://lithium-launchpad-cms.s3.eu-west-2.amazonaws.com/uploads/VH_token_icon_01_aa3f22ef69.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2022-01-10T17:00:00.000Z',
        end: '2022-01-10T20:00:00.000Z',
        price: 0.05,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.05,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1650031202/v2/Group_328_w2itlo.png',
          },
          darkTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649933423/v2/1490_zeoqjh_qz79uf.jpg',
          },
        },
        projectThumbnail: null,
        featuredProjectImage: null,
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 73.1,
    },
    isBusd: true,
    privateEnd: 1641844800,
    privateStart: 1641834000,
    privateTokenPrice: '50000000000000000',
    tokenName: 'Vault Hill',
    tokenSymbol: 'VHC',
    totalSaleSupply: '8e+24',
  },
  {
    cmsDetails: {
      name: 'Paycer',
      initialAddress: null,
      poolAddress: '0xfc83d4b462ca3baf47bbf23184d4a788bb05d9a7',
      ticker: 'PCR',
      totalSupply: '5454545',
      decimals: '18',
      publicThreshold: null,
      crossChainLink: 'matic',
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '5454545',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: null,
      about: {
        highlightsText:
          '0.03%. Thats the average global interest rate across so-called developed nations whilst the average REPORTED rate of inflation runs at nearly 4%. That means for every penny saved in a traditional bank account, you actually lose money and purchasing power in real terms.\nOne of the biggest applications of the blockchain has been decentralised finance (Defi) which aims to solve this problem, cut our rent seeking middlemen, and to quote John Lennon - Bring back power to the people.\nPaycer aims to do this by disrupting the low interest rate banking by offering high interest rates to savers via smart, Defi based financial services. Their mission is to provide simple and secure financial products built on blockchain technology, and through the development of an intuitive aggregator product - wants to enable individuals to amass personal wealth and create passive income.\n- Defi protocol and platform\n- Both a regulated (BAFIN) and Crypto native product in one ERC20 token (Polygon)\n- Passive income generation via intuitive dashboard\n- Website and app product\n- Experienced blockchain team with serious experience',
        productText:
          "The Paycer platform is a web application that will be accessible via a website and, later, via an app. The platform will offer numerous functions and financial services and will be primarily a B2C platform targeting mainstream customers. The Paycer protocol will act as a second blockchain-based backend for the Paycer platform and will connect it with the DeFi and blockchain space. The Paycer platform will link the Paycer protocol to the existing banking system, enabling a bridge between traditional and decentralized banking.\n### Paycer Wallet\nThe Paycer wallet will be a fully functional crypto wallet compliant with ERC20 standards, and open to be used by anyone in the world. The Paycer wallet will serve as the entry point for different blockchain-based financial services. For funds transferred from the Paycer bank account to the Paycer wallet, a daily interest rate will be paid.\nThe technical implementation could also involve the use of crypto custody providers, as the storage of cryptocurrencies requires an approval from the BaFin (German finance authority). In this case, the crypto deposits or rather the private keys would be held in custody by a specialized provider with an existing license. Future implementations could also allow the client to voluntarily own a private key, although this would transfer all risk to the client, and we would advise against this. This is because Paycer's main focus is on providing simple and secure crypto services for all types of users. For more advanced users it will also be possible to interact with the Paycer ecosystem and services by utilizing their own wallet.\n### Bank Account\nThe Paycer bank account will be the user's gateway between traditional finance and DeFi. The Paycer bank account will be a fully functional account like the accounts provided by banks. The bank account will be created once the user has finished his KYC (know your customer) process. This check is necessary to comply with legal requirements. Users will have several options to transfer money to their Paycer bank account, such as a SEPA transfer. All or part of the balance in the bank account can be sent to the Paycer wallet. Paycer will therefore need to get a banking licence from BaFin or establish a partnership with a partner bank to get a faster market entry.\n### Lending\nPaycer will provide different lending services on the Paycer platform, which will require cryptocurrency collateral that needs to be stored in the Paycer wallet. The user can then receive a loan in a coin of his choice. Only 50% of the collateral value can be taken as a loan. If the deposited collateral falls heavily in price, the borrower is informed and has a certain period of time to increase his collateral. Otherwise, the collateral might be liquidated to get the loan back. The collateral could also be provided in stablecoins to reduce the risks. The lending system will also contribute to the yields generated by Paycer.\n### Earn Interest\nOne of the main functions of the Paycer platform will be to earn interest as passive income. To generate interest, clients' deposits are invested in a portfolio of selected DeFi products (strategies). Thereby, only the amounts deposited in the Paycer wallet will be used for the generation and calculation of interest. The interest is calculated and paid on a daily basis. Paycer aims to ensure a safe and stable interest rate and therefore invests only in known products with a high total volume. The swap from fiat to crypto will be processed over an external on-ramp service partner.",
        problemText:
          'Today, many people are losing their wealth because they do not have the knowledge or the will to invest their money properly. Not long ago, it was possible to get around 5% or more interest on personal savings from a bank. Times have changed, and there is a great deal of money stored in bank accounts without earning interest and even costing additional fees. In Germany, most banks have begun to charge penalty interest of 0.5% per year for deposits above 50k EUR. The investor does not earn any return on capital; they lose part of the value to inflation and still have to pay a fee to the bank. Still, relatively few people have invested in cryptocurrencies, and even fewer have invested in DeFi or know of its existence. Cryptocurrencies are a countermovement in reaction to fiat money, which can be distributed by central banks in endless quantities.\nThis is exactly why Satoshi Nakamoto invented Bitcoin shortly after the financial crisis of 2008. Entering the crypto market has become much easier in recent years, but this also leads to situations in which inexperienced users can easily lose their money. The DeFi market is changing and adapting quickly, and it is quite difficult for inexperienced users to enter it. For the majority of people, dealing with new technologies is a significant challenge anyway. Third parties are still needed to provide support and an additional security layer, especially for novice users.',
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          'Paycer will offer a financial service allowing anyone to earn a passive income. Therefore, there are two main components: the Paycer protocol and the Paycer platform. The Paycer protocol is a mostly smart-contract-based protocol that aggregates DeFi protocols cross chain to create new investment products. Experienced crypto users can interact directly with the Paycer protocol to receive high and stable interest rates. However, the main purpose of the Paycer product remains to provide high interest rates to inexperienced mainstream users. The Paycer platform will offer simple user interfaces and processes that hide all the DeFi complexity. This should allow everyone to generate a passive income in the DeFi domain. The starting point in using the Paycer platform is fiat money; this will lower the barriers for new investors.',
        shortBio: null,
        links: [],
        logo: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1641989713/Paycer_20Logo_20Icon_i5yglf.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2022-01-05T17:00:00.000Z',
        end: '2022-01-05T20:00:00.000Z',
        price: 0.055,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.12,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168909/v2/pay1470x600_meb4pt.png',
          },
          darkTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168909/v2/pay1470x600_meb4pt.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168909/v2/pay290x180_a7jx18.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168909/v2/pay510x510_bb1imb.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 139.3,
    },
    isBusd: true,
    privateEnd: 1641412800,
    privateStart: 1641402000,
    privateTokenPrice: '55000000000000000',
    tokenName: 'Paycer',
    tokenSymbol: 'PCR',
    totalSaleSupply: '5.454545e+24',
  },
  {
    cmsDetails: {
      name: 'Astra Guild',
      initialAddress: null,
      poolAddress: '0x9154132fcf4b25f51f20cbc030303099a55a79e9',
      ticker: 'AGV',
      totalSupply: '1500000',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '1500000',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: 275,
      crossChainLink: 'ethereum',
      about: {
        highlightsText:
          'Astra Guild Ventures (AGV) is a play-to-earn gaming guild. Built as a DAO, AGV is focused on bridging the gap between investors and players in NFT games. Following the DAO’s launch last July of 2021, AGV has already established over 2,000+ Axie Infinity scholars and equity in anticipated games such as Kart Racing League (also owned by Mark Cuban!), and Realms of Ethernity by the Florida-based gaming developers, Blue Monster Games Inc.\nHaving achieved huge traction — raising $5.5m over Seed and Series A rounds from some serious blue-chip investors, they are now looking to launch their native token to support the further development of the eco-system with a massive marketing budget and ambitious plans to become the largest DAO by mid-2022.\n- One of the largest Play-to-Earn gaming guilds in the world\n- Killer team and advisory board to drive the project\n- An established business model with $800,000 monthly revenue\n- First DAO to fully disclose earnings through a real-time dashboard and publicly available assets list\n- One of the fastest-growing communities in pre-launch crypto (75k Facebook, 50,000 Discord, and 13k on the TG announcement channel alone)\n- Technology is fully operational and tested',
        productText: null,
        problemText:
          'With the increasing popularity of NFTs and Play-to-Earn games, there have been more and more opportunities arising. If you’re an avid crypto investor, then you know the struggle of having to research projects, manage your NFT assets, and learn how to play P2E games. It’s time-consuming and requires a lot of effort that could be better spent elsewhere.\n- Investors have the capital they wish to earn a yield on but no expertise in profitable PTE games and/or no time to play.\n- Players have built enormous skills via gaming however don’t have large enough levels of capital.\n- Low profit-sharing back to DAO with no / little transparency.',
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          "Astra Guild Ventures (AGV) offers investors who don't have the time to learn and manage their NFTs a way out by connecting them with players who want to earn some extra money while also getting access to these NFT assets that they otherwise can’t afford.\nAGV procures assets on behalf of the investors and lends out those assets to recruited players, while also providing training, in exchange for a portion of their earnings - maximizing the earning potential for investors, players, and AGV. Profit is shared between token holders, players, managers, and the gaming guild DAO treasury enabling them to invest and grow more — with every win comes more capital to drive marketing, adoption, and growth. It's that simple.\nIn addition to this, AGV has built and deployed an innovative and transparent earnings dashboard that tracks the earnings of all its guilds and NFT assets in real-time for its stakeholders.",
        shortBio: null,
        links: [],
        logo: {
          url: 'https://lithium-launchpad-cms.s3.eu-west-2.amazonaws.com/uploads/AGV_Coin_f5d0c60463.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2021-12-07T17:00:00.000Z',
        end: '2021-12-07T19:00:00.000Z',
        price: 0.2,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.25,
      },
      vestingPoints: [],
      media: {
        topBanner: null,
        projectThumbnail: null,
        featuredProjectImage: null,
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 143.6,
    },
    isBusd: true,
    privateEnd: 1638903600,
    privateStart: 1638896400,
    privateTokenPrice: '200000000000000000',
    tokenName: 'Astra Guild',
    tokenSymbol: 'AGV',
    totalSaleSupply: '1.5e+24',
  },
  {
    cmsDetails: {
      name: 'SolChicks',
      initialAddress: null,
      poolAddress: '0x2f9dda42a8dce1bb7ccc2689ae798ef8cc5d2fb1',
      ticker: 'LthCHICKS',
      totalSupply: '10000000',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '10000000',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: 940,
      crossChainLink: 'solana',
      about: {
        highlightsText:
          'Continuing the theme of GameFi ushering in the end of 2021, ZAP is proud to present the SolChicks IDO to the community. The P2E game, operating on the Solana blockchain, is currently one of the most hyped GameFi IDO’s in the market launching across roughly 20 launchpads, having raised $4m in their Seed round. Solana has been having its fair share of the limelight as on of the, if not the, best performing Layer 1 in the market. It’s only logical that hotly anticipated projects built on top of it, such as SolChicks, are destined for the same trajectory.\n- Online social NFT based game on Solana\n- PvP or Collaborative game modes\n- Collect, bond, and train your SolChicks to be the best\n- Browser and Mobile compatible (PC only for now)\n- Limited to 10,000 SolChicks with varying rarity attributes\n- Updates such as Marketplace, Breeding, Land, Gangs, and more',
        productText:
          'SolChicks’ mission is simple. They plan to be the leading fantasy NFT PVP and P2E gaming ecosystem on the Solana blockchain. The game is built around the SolChick NFT collectables which provide the foundation of the unique gaming metaverse for players to explore.\n### Play 2 Earn (P2E)\nThere are multiple ways to earn through playing SolChicks and interacting with the suite of feature rich applications the developers are building into the experience. The $CHICKS token is the utility token at the heart of SolChicks and will provide players holding it governance rights. Being paid in $CHICKS is determined through weekly leaderboard / MMR rankings, encouraging players to become skilled and experienced in the game.\nThe capacity to earn doesn’t stop there though. There are 3 other ways in which players can turn time spent on the game into earnings:\n- Breeding — players are able to breed SolChicks to unlock rare attributes and sell them in the marketplace.\n- In Game Rewards — NFT items, Shards of Love (SLC), and more can all be earned through gameplay and then traded on real world exchanges.\n- Earning SolCoins — This is the in-game currency that players can use and exchange for various purposes in the game to improve their return on time.\n### PVP\nPvP mode allows players to test their skills and pit their SolChicks against each other in the field of battle. This essential gameplay mode allows team battles resulting in your SolChicks gaining experience and winning you prizes.\nThe innovative algorithm means that the battleground will match you with teammates and opponents of similar levels and skill. In this arena of cuteness it is up to you to showcase your SolChicks strength and ability to players from all over the Solana universe!\n### Raid\nOnly the most battle hardened SolChicks have the opportunity to participate in the coveted Raid game mode. Raids are designed to have a significant increase in difficulty and allow seasoned players to team up in Co-Op battles. This game mode, whilst more challenging, comes with the allure of greater spoils for players. Good luck.\n### Bond\nBonding with your chick is important. Baby SolChicks are fragile creatures that require your care and attention in order to grow big and strong in order to survive everything the metaverse throws at them. There are two ways that players are able to bond with their SolChicks, playing with them and feeding them. Make sure you strike the right balance.\n### Train\nTraining is a crucial element to your SolChick becoming a force to be reckoned with in the metaverse. Bonding with your SolChick and winning PvP battles will result in experience points being gained. Once the EXP gauge has been maxed out for your SolChick, it will level up and take you one step closer to becoming the fiercest SolChick of them all.',
        problemText:
          'Across web 2.0 and traditional gaming there lacked incentives and ownership concepts for players. In recent times game studios attempted to address this lack of reward through structures such as the loot crate, giving players the opportunity to exchange a consumable virtual item for further random virtual items (or loot).\nThe problem with this, is that beyond the realm of the game itself the player does not physically own any of this redeemed loot or in game items. Additionally, we are not able to express our authenticity, we all have very cool online usernames and profile pictures; but there is no immersive audiovisual component that does justice to our individuality.',
        businessModalText:
          'SolChicks are incorporating innovative P2E economics at the core of their game offering, incentivising players with real world earning potential in return for their time playing the game. This is further compounded through in game rewards such as NFT’s which are tradable on real world exchanges providing additional value and incentive to players. As demand for the game and elements of digital limited ownership increases the value of their token, $CHICKS, will experience a increase in buy pressure valuing the project up there with some of the titans of GameFi.',
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          'GameFi as a concept itself is combining gaming and finance, delivering real physical ownership and financial incentive for players to immerse themselves in their resepective universes, and increasingly so, cross-universe. The core value being the return of ownership of digital assets to the players not the platform. This not only boosts incentive but works to increase trust between game and player as the world of gaming on web 3.0 continues to grow at an impressive rate.\nGameFi began its uptrend at a particularly interesting time, at a point when covid was rampant and unemployment spiking globally. Suddenly, more and more people were looking toward crypto, DeFi and now GameFi as their livelihood and additional source of income. SolChicks combines an exciting combination of P2E and NFT’s to create a carefully curated economy whereby there is incentive and opportunity to financially benefit throughout the game in its entirety, even if you’re not playing.\nSolChicks is looking to tap the largest gaming markets globally, China, North America and Japan. This vision is to introduce many traditional gamers to the concept of P2E and digital ownership with real world tangible value.',
        shortBio: null,
        links: [],
        logo: {
          url: 'https://lithium-launchpad-cms.s3.eu-west-2.amazonaws.com/solchicks_bbc5c132e6.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2021-11-26T17:00:00.000Z',
        end: '2021-11-26T20:00:00.000Z',
        price: 0.05,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.075,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168910/v2/sol1740x600_zqmh5r.png',
          },
          darkTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168910/v2/sol1740x600_zqmh5r.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168909/v2/sol290x180_h6ckc1.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168909/v2/sol510x510_sgw86z.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 126.5,
    },
    isBusd: true,
    privateEnd: 1637956800,
    privateStart: 1637946000,
    privateTokenPrice: '50000000000000000',
    tokenName: 'SolChicks',
    tokenSymbol: 'LthCHICKS',
    totalSaleSupply: '1e+25',
  },
  {
    cmsDetails: {
      name: 'BitHotel',
      initialAddress: null,
      poolAddress: '0xf08555d752efdbfe6c1442ffec968eec96b78597',
      ticker: 'BTH',
      totalSupply: '12500000',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '12500000',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: 2075,
      about: {
        highlightsText:
          'GameFi is experiencing its time in the crypto limelight with some of the largest projects in the exceeding that coveted $1bn market cap, and the IDO’s of play-to-earn projects are consistently over subscribed and massively hyped. Bit Hotel is a novel, online, social, NFT based game that uses its own currency in game, launching on BSC across Superlauncher, Ferrum Network, Enjinstarter, and ZAP Ventures.\n- Online social NFT based game\n- Meet, Chat, and Compete with other players\n- Collect rare characters\n- Browser and Mobile compatible\n- Gamified Yield Farming and Staking\n- Marketplace, Leaderboard, Events, Rooms, Conference Rooms',
        productText:
          'PRODUCT\nThe Bit Hotel product is a comprehensive yet intricate mix of social media, online gaming, NFT’s, and play-to-earn with all the elements combining to offer crypto gaming connoisseurs the web 3.0 upgrade of Habbo Hotel. For those old enough to remember and involved in the crypto gaming space, the nostalgia alone is enough to want to dive in head first and explore this revolutionary NFT based gaming experience.\n#### Play 2 Earn (P2E)\nIn-game items and in-game currency can be earned by the player through completing multiplayer mini-games and challenges. Items in-game will have different levels of scarcity and will be freely tradeable through an in-game market system.\n#### Marketplace\nBit Hotel will implement a marketplace where players and investors can buy and sell the NFT’s. The NFT consists of different digital objects; e.g. characters, chambers and furniture.\n#### Staking\nThere is the possibility to stake tokens in-game. A player could for example invest in a bar by staking the tokens and in return the player will be rewarded.\n#### Socialise\nBit hotel will consist of general and private rooms where player can interact with each other through text-based communication. We see a huge gap in the market when it comes social & community aspects on the blockchain. Currently, the only viable options are either Discord or Telegram; this mainly has to do with both the anonymity and accesibility that those platforms have.\n#### Scoreboard\nBit Hotel will consist of a scoreboard with different types of tournaments. This scoreboard will show the top 20 players (in terms of wins) in the different mini-games, and every (week/month) the top 5 players get rewarded a rare NFT.\n#### Relationships\nIn order to incentivize existing communities to set gatherings and meet up in the Bit Hotel metaverse players will be able to proclaim in-game relationships. Being in a relationship will have perks and proivde unique Rewards to players. Similar to breeding in other blockchain games this can become a lucrative endeavour to invest time in.',
        problemText:
          'Across web 2.0 and traditional gaming there lacked incentives and ownership concepts for players. In recent times game studios attempted to address this lack of reward through structures such as the loot crate, giving players the opportunity to exchange a consumable virtual item for further random virtual items (or loot).\nThe problem with this, is that beyond the realm of the game itself the player does not physically own any of this redeemed loot or in game items. Additionally, we are not able to express our authenticity, we all have very cool online usernames and profile pictures; but there is no immersive audiovisual component that does justice to our individuality.',
        businessModalText:
          'The token revenue and utility model for Bit Hotel is as intrinsic as it is impressive, ensuring inflows if major new NFT assets whilst mitigating against sell offs of the native $BTH token',
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          'GameFi as a concept itself is combining gaming and finance, delivering real physical ownership and financial incentive for players to immerse themselves in their resepective universes, and increasingly so, cross-universe. The core value being the return of ownership of digital assets to the players not the platform. This not only boosts incentive but works to increase trust between game and player as the world of gaming on web 3.0 continues to grow at an impressive rate.\nGameFi began its uptrend at a particularly interesting time, at a point when covid was rampant and unemployment spiking globally. Suddenly, more and more people were looking toward crypto, DeFi and now GameFi as their livelihood and additional source of income. Bit Hotel combines an exciting combination of P2E and NFT’s to create a carefully curated economy whereby there is incentive and opportunity to financially benefit throughout the game in its entirety, even if you’re not playing.\nThe majority of the demographic using the blockchain belongs to generation Y, who grew up with those classic 8-bit graphics. In the Bit Hotel metaverse, we try to give every user individuality and an in-game identity within that 8-bit nostalgic charm. Practically, users will be able to purchase NFT characters & rooms, in which they can invite their friends, host small gatherings and use as their own personal social hub. They will be able to decorate their rooms with furniture, NFT artwork, and other artifacts.\nWe will also be selling conference rooms/ club houses to DAOs and communities; in which one could host AMA’s, organize IDOs, and other communal activities. Only members with a custom NFT characters will have exclusive access to their particular conference room. Bit Hotel will also be a framework, on which established companies will be able to host their groundbreaking technology and create a collaborative process with interoperability between projects as that is the beauty of blockchain. We want to make Bit Hotel as accessible as possible, our metaverse will therefore be mobile compatible too.',
        shortBio: null,
        links: [],
        logo: {
          url: 'https://lithium-launchpad-cms.s3.eu-west-2.amazonaws.com/uploads/token_design_bithotel_e4c9863b77.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2021-11-24T18:00:00.000Z',
        end: '2021-11-24T19:00:00.000Z',
        price: 0.012,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.017,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168908/v2/bit1740x600_rzh0fy.png',
          },
          darkTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168908/v2/bit1740x600_rzh0fy.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168907/v2/bit290x180_khl6y1.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168907/v2/bit510x510_gw6uxk.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 283,
    },
    isBusd: true,
    privateEnd: 1637780400,
    privateStart: 1637776800,
    privateTokenPrice: '12000000000000000',
    tokenName: 'BitHotel',
    tokenSymbol: 'BTH',
    totalSaleSupply: '1.25e+25',
  },
  {
    cmsDetails: {
      name: 'One Button',
      initialAddress: null,
      poolAddress: '0x43161557654e05e4d29845bae8d8247373741197',
      ticker: 'OBT',
      totalSupply: '2000000',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '2000000',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: 470,
      about: {
        highlightsText: null,
        productText: null,
        problemText: null,
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText: null,
        shortBio: null,
        links: [],
        logo: {
          url: 'https://lithium-launchpad-cms.s3.eu-west-2.amazonaws.com/uploads/one_Button_logo_749ffc677f.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2021-10-14T17:00:00.000Z',
        end: '2021-10-15T17:00:00.000Z',
        price: 0.1,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.115,
      },
      vestingPoints: [],
      media: {
        topBanner: null,
        projectThumbnail: null,
        featuredProjectImage: null,
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 170.3,
    },
    isBusd: true,
    privateEnd: 1634317200,
    privateStart: 1634230800,
    privateTokenPrice: '100000000000000000',
    tokenName: 'One Button',
    tokenSymbol: 'OBT',
    totalSaleSupply: '2e+24',
  },
  {
    cmsDetails: {
      name: 'Buffer Finance',
      initialAddress: null,
      poolAddress: '0x839666075a5cd7b6c956561849a9b9462e0f6b4d',
      ticker: 'IBFR',
      totalSupply: '3000000',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '3000000',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: 1700,
      about: {
        highlightsText: null,
        productText:
          'Buffer is a non-custodial options trading platform with the bi-directional liquidity pool fully managed by smart contracts. This means that multiple liquidity pools are not required and that both Buy and Put options can be written from the same pool. In similar vein to ZAP, Buffer want to simplify options trading, making it accessible to the everyday retail investor.',
        problemText:
          'Traditional options trading is confusing, inflexible, and largely inaccessible to the everyday retail investor. Buffer is revolutionising the space bringing highly customisable options trading to blockchain. Removing the requirement for counterparties, and streamlining the trading and settlement processes Buffer are looking to solve the inefficiencies in a largely uninnovated space.',
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText:
          'Buffer gamifies options trading, allowing retail investors to participate at ease. Buffer is also the only protocol to offer offer options on BNB, despite it being the 3rd largest cryptocurrency by market cap. This problem is compounded with the only options available through centralised exchanges being highly illiquid and only accessible in very few markets.',
        shortBio: null,
        links: [],
        logo: {
          url: 'https://lithium-launchpad-cms.s3.eu-west-2.amazonaws.com/uploads/ibuffer_logo_507dd82956%20%281%29.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2021-10-27T08:00:00.000Z',
        end: '2021-10-27T11:00:00.000Z',
        price: 0.047,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.068,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168907/v2/Buffer_Hero_1470x600_1_nglfqx.png',
          },
          darkTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168907/v2/Buffer_Hero_1470x600_1_nglfqx.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168908/v2/Buffer_Transparent_290x180_1_pqkqq8.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168907/v2/Buffer_Transparent_290x180_1_copy_zlkfin.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 150.6,
    },
    isBusd: true,
    privateEnd: 1635332400,
    privateStart: 1635321600,
    privateTokenPrice: '47000000000000000',
    tokenName: 'Buffer Finance',
    tokenSymbol: 'IBFR',
    totalSaleSupply: '3e+24',
  },
  {
    cmsDetails: {
      name: 'ViceWrld',
      initialAddress: null,
      poolAddress: '0x9d247f413f6a495bf8ee66811e38fb96b345e969',
      ticker: 'VICE',
      totalSupply: '12389670',
      decimals: '18',
      publicThreshold: null,
      status: 'Scheduled',
      publicBuyLimit: '10',
      token: 'dummyToken',
      claimPct: null,
      claimTime: null,
      airdrop: null,
      tokenFeePct: null,
      valueFeePct: null,
      isDeploy: null,
      mainNet: null,
      totalSaleSupply: '12389670',
      airDrop: '0',
      isOldPool: false,
      totalRaise: '10',
      chainID: 56,
      athSinceIDO: 1500,
      about: {
        highlightsText: null,
        productText: null,
        problemText: null,
        businessModalText: null,
        marketText: null,
        investorsText: null,
        tokenUtility: null,
        solutionText: null,
        shortBio: null,
        links: [],
        logo: {
          url: 'https://lithium-launchpad-cms.s3.eu-west-2.amazonaws.com/uploads/logo_d5c79c1811.png',
        },
        highlightsVideo: null,
        whitePaper: null,
      },
      privateSale: {
        id: 254,
        start: '2021-09-01T17:00:00.000Z',
        end: '2021-09-01T20:00:00.000Z',
        price: 0.0055,
      },
      publicSale: {
        id: 254,
        start: '2022-04-06T13:50:00.000Z',
        end: '2022-04-06T14:00:00.000Z',
        price: 0.006,
      },
      vestingPoints: [],
      media: {
        topBanner: {
          lightTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168910/v2/vc1470x600_vyioaj.png',
          },
          darkTheme: {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168910/v2/vc1470x600_vyioaj.png',
          },
        },
        projectThumbnail: {
          url: 'https://res.cloudinary.com/lithium/image/upload/v1649168908/v2/LITHIUMPOOL_290_180_px_vxwxvv.png',
        },
        featuredProjectImage: [
          {
            url: 'https://res.cloudinary.com/lithium/image/upload/v1649168910/v2/vc510x510_ijwvdf.png',
          },
        ],
        highlightsVideo: null,
      },
      topLinks: null,
      vestingTableRow: null,
      whitelistCSV: null,
      projectThumbnail: null,
      featuredProjectImage: null,
      highlightsVideo: null,
      progress: 253.5,
    },
    isBusd: true,
    privateEnd: 1630526400,
    privateStart: 1630515600,
    privateTokenPrice: '5500000000000000',
    tokenName: 'ViceWrld',
    tokenSymbol: 'VICE',
    totalSaleSupply: '1.238967e+25',
  },
]
